// Python Cheat Sheets & Subtopics
import ProblemSol_Debugging_CS from "../Python/NestedConditions/ProblemSol_Debugging_CS";
import Problem_sol_Debugging_4_CS from "../Python/ComparingStr&NamingVar/Problem_sol_Debugging_4_CS";
import Problem_sol_Debugging_5_CS from "../Python/ComparingStr&NamingVar/Problem_sol_Debugging_5_CS";

import Problem_sol_6_CS from "../Python/LoopContronStmts/Problem_sol_6_CS";
import Problem_sol_7_CS from "../Python/LoopContronStmts/Problem_sol_7_Cs";

import Variables_DT_CS_2 from "../Python/IntroductiontoPython/Variables_DT_CS_2";
import Pro_W_P_CS_1 from "../Python/IntroductiontoPython/Pro_W_P_CS_1";
import Seq_OF_Instruction_CS_3 from "../Python/IntroductiontoPython/Seq_OF_Instruction_CS_3";
import Inp_Oup_Basics_CS_1 from "../Python/Inp_Oup_Basiscs/Inp_Oup_Basics_CS_1";
import How_to_Debug_Code from "../Python/Inp_Oup_Basiscs/How_to_Debug_Code";
import Coding_Pratice_Walkthrough_2 from "../Python/Inp_Oup_Basiscs/Coding_Pratice_Walkthrough_2.js";
import Type_Con_CS_2 from "../Python/Inp_Oup_Basiscs/Type_Con_CS_2";
import ConditionalStmts_CS_3 from "../Python/Operators&ConditionalStmts/ConditionalStmts_CS_3";
import LogicalOperators_CS_2 from "../Python/Operators&ConditionalStmts/LogicalOperators_CS_2";
import RelationOperator_CS_1 from "../Python/Operators&ConditionalStmts/RelationOperator_CS_1";
import Nested_con_CS_1 from "../Python/NestedConditions/Nested_con_CS_1";
import ForLoop_CS_2 from "../Python/Loops/ForLoop_CS_2";
import Approachto_HollowPattern_CS from "../Python/Loops/Approachto_HelloPattern_CS";
import String_Methods_CS from "../Python/Loops/String_Methods_CS";
import Loops_CS_2 from "../Python/Loops/Loops_CS";
import NestedLoops_CS_1 from "../Python/LoopContronStmts/NestedLoops_CS_1";
import String_Methods_Additional_Material_CS from "../Python/Loops/String_Methods_Additional_Material_CS";
import LoopControlStmts_CS_2 from "../Python/LoopContronStmts/LoopConrolStmts_CS_2";
import ComparingStrAndNamingVar_CS_1 from "../Python/ComparingStr&NamingVar/ComparingStr&NamingVar_CS_1";
import List_CS_1 from "../Python/Lists/List_CS_1";
import Workingwith_Lists_CS from "../Python/Lists/Workingwith_Lists_CS.js";
import Workingwith_Data_Time_CS from "../Python/Miscellaneous/Workingwith_Data_Time_CS.js";
import Lists_Strings_CS_1 from "../Python/Functions/Lists_String_CS_1";
import Functions_CS_2 from "../Python/Functions/Functions_CS_2";
import Function_Argu_CS_3 from "../Python/Functions/Function_Argu_CS_3";
import Built_in_Fun_CS_1 from "../Python/Recursion/Built_in_Fun_CS_1";
import FunCallStackRecursion from "../Python/Recursion/FunCallStack_Recursion";
import ListMethods from "../Python/Recursion/ListMethods";
import Tuples_Sequences_CS_1 from "../Python/Tuples&Sets/Tuples_Sequences_CS_1";
import Sets_CS_2 from "../Python/Tuples&Sets/Sets_CS_2";
import Set_Operations_CS_3 from "../Python/Tuples&Sets/Set_Operations_CS_3";
import Dictionaries_CS_2 from "../Python/Dictionaries/Dictionaries_CS_2";
import Builtin_Fun_Additional_Material_CS from "../Python/Dictionaries/Builtin_Fun_Additional_Material_CS.js";
import NestedList_StringFormatting_CS_1 from "../Python/Dictionaries/NestedList_StringFormating_CS_1";
import Working_With_Dictionaries_CS_3 from "../Python/Dictionaries/Working_With_Dictionaries_CS_3";
import Introductionto_OOP_CS_1 from "../Python/IntroductiontoOOP/Introductionto_OPP_CS_1";
import Introductionto_OOP_CS_2 from "../Python/IntroductiontoOOP/Introductionto_OOP_CS_2.js";
import Classes_Object_CS_3 from "../Python/IntroductiontoOOP/Classes_Object_CS_3";
import Attributes_Methods_CS_4 from "../Python/IntroductiontoOOP/Attributes_Methods_CS_4";
import Inheritance_Part1_CS_5 from "../Python/IntroductiontoOOP/Inheritance_Part1_CS_5";
import Inheritance_Part2_CS_2 from "../Python/IntroductiontoOOP/Inheritance_Part2_CS_2";
import Python_Standard_Library_CS_1 from "../Python/Miscellaneous/Python_Standard_Library_CS_1";
import Scope_Namespaces_CS_2 from "../Python/Miscellaneous/Scope_Namespaces_CS_2";
import Errors_Exceptions_CS_3 from "../Python/Miscellaneous/Errors_Exceptions_CS_3";
import Dates_Time_CS_4 from "../Python/Miscellaneous/Dates_Time_CS_4";
import Workingwith_Date_Time_CS from "../Python/Miscellaneous/Workingwith_Data_Time_CS.js";
import Python_Summary_CS_1 from "../Python/Revision/Python_Summary_CS_1";
import Python_Summary_CS_2 from "../Python/Revision/Python_Summary_CS_2";
import Python_Summary_CS_3 from "../Python/Revision/Python_Summary_CS_3";
import Python_Summary_CS_4 from "../Python/Revision/Python_Summary_CS_4";

//Flexbox
import Sizing_Ele_Handling_Overflow_CS from "../FlexBox/CSS_Flexbox/Sizing_Ele_Handling_Overflow_CS.js";
import Box_Sizing_CS from "../FlexBox/CSS_Flexbox/Box_Sizing_CS.js";
import Introductionto_CSS_Flexbox_CS from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_CS.js";
import Introductionto_CSS_Flexbox_CS_2 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_CS_2.js";
import Introductionto_CSS_Flexbox_CS_3 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_CS_3.js";

//Reactjs
import Introductionto_Reactjs_CS from "../Reactjs/Introductionto_Reactjs/Introductionto_Reactjs_CS.js";
import Components_Props_CS from "../Reactjs/Introductionto_Reactjs/Components_Props.CS.js";
import Lists_Keys_CS from "../Reactjs/Introductionto_Reactjs/Lists_Keys_CS.js";
import Class_Component_State1_CS from "../Reactjs/Class_Component_State1/Class_Component_State1_CS.js";
import Conditional_Render_CS from "../Reactjs/Class_Component_State1/Conditional_Render_CS.js";
import Class_Component_State2_CS from "../Reactjs/Class_Component_State2/Class_Component_State2_CS.js";
import Common_Mistakes_CS from "../Reactjs/Common_Mistakes/Common_Mistakes_CS.js";
import Debugging_Dev_Tool_CS from "../Reactjs/Debugging/Debugging_Dev_Tool_CS.js";
import Ondemand1_Session_CS from "../Reactjs/Working_With_Lists/Ondemand1_Session_CS.js";
import Ondemand2_Session_CS from "../Reactjs/Working_With_Lists/Ondemand2_Session_CS.js";
import Component_Life_Cycle_CS from "../Reactjs/Component_Life_Cycle/Component_Life_Cycle_CS.js";
import React_Router1_CS from "../Reactjs/React_Router/React_Router1_CS.js";
import React_Router2_3_CS from "../Reactjs/React_Router/React_Router2_3_CS.js";
import Common_M_Part2_CS from "../Reactjs/React_Router/Common_M_Part2_CS.js";
import Authentication_CS from "../Reactjs/Authentication/Authentication_CS.js";
import Authentication_2_CS from "../Reactjs/Authentication/Authentication_2_CS.js";
import Authentication_3_CS from "../Reactjs/Authentication/Authentication_3_CS.js";
import Common_Mistake_3_CS from "../Reactjs/Authentication/Common_Mistake_3_CS.js";
import Authentication_P4_CS from "../Reactjs/Authentication2/Authentication_P4_CS.js";
import SortingProducts_CS from "../Reactjs/Authentication2/SortingProducts_CS.js";
import More_React_CS from "../Reactjs/More_React_Concepts/More_React_CS.js";
import Third_Party_CS from "../Reactjs/Third_Party/Third_Party_CS.js";
import Recharts from "../Reactjs/Third_Party/Recharts.js";
import React_Chrono_CS from "../Reactjs/Third_Party/React_Chrono_CS.js";
import React_Slick from "../Reactjs/Third_Party/React_Slick.js";
import React_Pop from "../Reactjs/Third_Party/React_Pop.js";
import React_Context_CS from "../Reactjs/React_Context/React_Context_CS.js";
import React_Cpart2_CS from "../Reactjs/React_Context/React_Cpart2_CS.js";
import React_Cpart3_CS from "../Reactjs/React_Context/React_Cpart3_CS.js";
import React_Cpart4_CS from "../Reactjs/React_Context/React_Cpart4_CS.js";
import Styled_Compo_CS from "../Reactjs/Styled_Components/Styled_Compo_CS.js";

//React MCQ
import Introductionto_Reactjs_MCQ from "../Reactjs/Introductionto_Reactjs/Introductionto_Reactjs_MCQ.js";
import Components_Props_MCQ from "../Reactjs/Introductionto_Reactjs/Components_Props_MCQ.js";
import Lists_Keys_MCQ from "../Reactjs/Introductionto_Reactjs/Lists_Keys_MCQ.js";
import Class_Component_State1_MCQ from "../Reactjs/Class_Component_State1/Class_Component_State1_MCQ.js";
import Conditional_Render_MCQ from "../Reactjs/Class_Component_State1/Conditional_Render_MCQ.js";
import Class_Component_State2_MCQ from "../Reactjs/Class_Component_State2/Class_Component_State2_MCQ.js";
import Common_Mistakes_MCQ from "../Reactjs/Common_Mistakes/Common_Mistakes_MCQ.js";
import Debugging_Dev_Tool_MCQ from "../Reactjs/Debugging/Debugging_Dev_Tool_MCQ.js";
import Ondemand1_Session_MCQ from "../Reactjs/Working_With_Lists/Ondemand1_Session_MCQ.js";
import Ondemand2_Session_MCQ from "../Reactjs/Working_With_Lists/Ondemand2_Session_MCQ.js";
import Component_Life_Cycle_MCQ from "../Reactjs/Component_Life_Cycle/Component_Life_Cycle_MCQ.js";
import React_Router1_MCQ from "../Reactjs/React_Router/React_Router1_MCQ.js";
import React_Router2_3_MCQ from "../Reactjs/React_Router/React_Router2_3_MCQ.js";
import Common_M_Part2_MCQ from "../Reactjs/React_Router/Common_M_Part2_MCQ.js";
import Authentication_MCQ from "../Reactjs/Authentication/Authentication_MCQ.js";
import Authentication_2_MCQ from "../Reactjs/Authentication/Authentication_2_MCQ.js";
import Authentication_3_MCQ from "../Reactjs/Authentication/Authentication_3_MCQ.js";
import Common_Mistake_3_MCQ from "../Reactjs/Authentication/Common_Mistake_3_MCQ.js";
import Authentication_P4_MCQ from "../Reactjs/Authentication2/Authentication_P4_MCQ.js";
import SortingProducts_MCQ from "../Reactjs/Authentication2/SortingProducts_MCQ.js";
import More_React_MCQ from "../Reactjs/More_React_Concepts/More_React_MCQ.js";
import Third_Party_MCQ from "../Reactjs/Third_Party/Third_Party_MCQ.js";
import React_Context_MCQ from "../Reactjs/React_Context/React_Context_MCQ.js";
import React_Cpart2_MCQ from "../Reactjs/React_Context/React_Cpart2_MCQ.js";
import React_Cpart3_MCQ from "../Reactjs/React_Context/React_Cpart3_MCQ.js";
import React_Cpart4_MCQ from "../Reactjs/React_Context/React_Cpart4_MCQ.js";
import Styled_Compo_MCQ from "../Reactjs/Styled_Components/Styled_Compo_MCQ.js";

// MCQ Wrapper
import MCQWrapper from "../SubtopicsPage/MCQWrapper";

//Static Website Classes
import A_Note_ON_BootStrap_Version_Class from "../StaticWebsite/DevelopingLayouts/A_Note_ON_BootStrap_Version_Class.js";
import Website_Behind_the_Scenes from "../StaticWebsite/WebSiteIntegration/Website_Behind_the_Scenes.js";
import Introductionto_Html from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_HTML.js";
import Introductionto_Css_1 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_1.js";
import Introductionto_Css_2 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_2.js";
import Introductionto_Css_3 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_3.js";
import Introductionto_Css_Boxmodel_1 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_1.js";
import Introductionto_Css_Boxmodel_2 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_2.js";
import Introductionto_Bootstrap_1 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_1.js";
import Introductionto_Bootstrap_2 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_2.js";
import FavouritePlaces_Section_1 from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_Section_1.js";
import Approachto_Develop_Layout_1 from "../StaticWebsite/DevelopingLayouts/Approachto_Develop_Layout_1.js";
import Favouriteplaces_Detailview_1 from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_DetailView_1.js";
import WebSite_Integration_1 from "../StaticWebsite/WebSiteIntegration/WebSite_Integration_1.js";
import WebSite_Integration_2 from "../StaticWebsite/WebSiteIntegration/WebSite_Integration_2.js";
import Html_HyperLinks_1 from "../StaticWebsite/WebSiteIntegration/HTML_HyperLinks_1.js";
import OnDemand_Session_1 from "../StaticWebsite/WebSiteIntegration/OnDemand_Session_1.js";
import Static_Mock_Test_1 from "../StaticWebsite/Mock_Tests/Static_Mock_Test_1.js";
import Static_Mock_Test_2 from "../StaticWebsite/Mock_Tests/Static_Mock_Test_2.js";
import Static_Website_Project from "../StaticWebsite/Mock_Tests/Static_Website_Project.js";
import Static_Coding_Assignment_1 from "../StaticWebsite/Assignments/Static_Coding_Assignment_1.js";
import Static_Coding_Assignment_2 from "../StaticWebsite/Assignments/Static_Coding_Assignment_2.js";
import Static_Coding_Assignment_3 from "../StaticWebsite/Assignments/Static_Coding_Assignment_3.js";
import Static_Course_Exam_Instruction from "../StaticWebsite/Static_Course_Exam/Static_Course_Exam_Instruction.js";
import Static_Course_Exam from "../StaticWebsite/Static_Course_Exam/Static_Course_Exam.js";

//Static Website Cheat Sheets
import Coding_Practice_Platform_Walkthrough from "../StaticWebsite/Css_BoxModel/Coding_Practice_Platform_Walkthrough.js";
import Introductionto_First_Project from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_First_Project.js";
import Introductionto_HTML_CS_1 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_HTML_CS_1";
import Introductionto_Css_CS_1 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_CS_1";
import Introductionto_Css_CS_2 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_CS_2";
import Introductionto_Css_CS_3 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_CS_3";
import Introductionto_Css_BoxModel_CS_1 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_CS_1";
import Introductionto_Css_BoxModel_CS_2 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_CS_2";
import Introductionto_BootStrap_CS_1 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_CS_1";
import Introductionto_BootStrap_CS_2 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_CS_2";
import Approachto_Develop_Layout_CS_1 from "../StaticWebsite/DevelopingLayouts/Approachto_Develop_Layout_CS_1";
import FavouritePlaces_DetailView_CS from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_DetailView_CS";
import FavouritePlaces_Section_CS_1 from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_Section_CS_1";
import OnDemand_Session_CS from "../StaticWebsite/WebSiteIntegration/OnDemand_Session_CS.js";
import HTML_HyperLinks_CS from "../StaticWebsite/WebSiteIntegration/HTML_HyperLinks_CS";
import Website_Integration_CS_1 from "../StaticWebsite/WebSiteIntegration/WebSite_Integration_CS_1";
import Website_Integration_CS_2 from "../StaticWebsite/WebSiteIntegration/WebSite_Integration_CS_2";
import StaticSummary_CS from "../StaticWebsite/Revision/Static_Summary_CS";
import Static_Coding_Pratice_1 from "../StaticWebsite/Css_BoxModel/Static_Coding_Pratice_1.js";
import Static_Coding_Pratice_2 from "../StaticWebsite/BootStrap/Static_Coding_Pratice_2.js";
import Static_Coding_Pratice_3 from "../StaticWebsite/BootStrap/Static_Coding_Pratice_3.js";
import Static_Coding_Pratice_4 from "../StaticWebsite/BootStrap/Static_Coding_Pratice_4.js";
import Static_Coding_Pratice_5 from "../StaticWebsite/DevelopingLayouts/Static_Coding_Pratice_5.js";
import Static_Coding_Pratice_6 from "../StaticWebsite/DevelopingLayouts/Static_Coding_Pratice_6.js";
import Static_Coding_Pratice_7 from "../StaticWebsite/WebSiteIntegration/Static_Coding_Pratice_7.js";
import Static_Coding_Pratice_8 from "../StaticWebsite/WebSiteIntegration/Static_Coding_Pratice_8.js";

//Responsive Website Cheat Sheets
import Introductionto_Responsive_WD_CS from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Introductionto_Responsive_WD_CS";
import Bootstrap_Grid_Sys_CS_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_CS_1";
import Bootstrap_Grid_Sys_CS_2 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_CS_2";
import Bootstrap_Navbar_CS from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Navbar_CS";
import Css_Selector_Inheritance_CS from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Selector_Inheritance_CS";
import Css_Specificity_Cascade_CS from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Specificity_Cascade_CS";
import Banner_Section_CS from "../ResponsiveWebsite/Developing_Layouts1/Banner_Section_CS";
import Explore_Menu_Section_CS from "../ResponsiveWebsite/Developing_Layouts1/Explore_Menu_Section_CS";
import Healthy_Delivary_Payments_CS from "../ResponsiveWebsite/Developing_Layouts1/Healthy_Delivary_Payments_CS";
import Why_Chooseus_Section_CS from "../ResponsiveWebsite/Developing_Layouts1/Why_Chooseus_Section_CS";
import CSS_Gradience_CS from "../ResponsiveWebsite/Developing_Layouts2/CSS_Gradience_CS";
import Followus_More_Styles_CS from "../ResponsiveWebsite/Developing_Layouts2/Followus_More_Styles_CS";
import Responsive_Summary_CS from "../ResponsiveWebsite/Revision/Responsive_Summary_CS";

//Responsive WebSite Classes
import Introductionto_Responsive_WD_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Introductionto_Responsive_WD_1.js";
import Bootstrap_Grid_Sys_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_1.js";
import Bootstrap_Grid_Sys_2 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_2.js";
import Bootstrap_Navbar_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Navbar_1.js";
import Css_Selector_Inheritance_1 from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Selector_Inheritance_1.js";
import Css_Specificity_Cascade_1 from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Specificity_Cascade_1.js";
import Banner_Section_1 from "../ResponsiveWebsite/Developing_Layouts1/Banner_Section_1.js";
import Explore_Menu_Section_1 from "../ResponsiveWebsite/Developing_Layouts1/Explore_Menu_Section_1.js";
import Why_Chooseus_Section_1 from "../ResponsiveWebsite/Developing_Layouts1/Why_Chooseus_Section_1.js";
import Healthy_Delivary_Payments_1 from "../ResponsiveWebsite/Developing_Layouts1/Healthy_Delivary_Payments_1.js";
import Followus_More_Styles_1 from "../ResponsiveWebsite/Developing_Layouts2/Followus_More_Styles_1.js";
import Css_Gradience_1 from "../ResponsiveWebsite/Developing_Layouts2/CSS_Gradience_1.js";
import Responsive_Coding_Pratice_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Responsive_Coding_Pratice_1.js";
import Responsive_Coding_Pratice_2 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Responsive_Coding_Pratice_2.js";
import Responsive_Coding_Pratice_3 from "../ResponsiveWebsite/CSS_Building_Blocks/Responsive_Coding_Pratice_3.js";
import Responsive_Coding_Pratice_4 from "../ResponsiveWebsite/CSS_Building_Blocks/Responsive_Coding_Pratice_4.js";
import Responsive_Coding_Pratice_5 from "../ResponsiveWebsite/Developing_Layouts1/Responsive_Coding_Pratice_5.js";
import Responsive_Coding_Pratice_6 from "../ResponsiveWebsite/Developing_Layouts1/Responsive_Coding_Pratice_6.js";
import Responsive_Coding_Pratice_7 from "../ResponsiveWebsite/Developing_Layouts1/Responsive_Coding_Pratice_7.js";
import Responsive_Coding_Pratice_8 from "../ResponsiveWebsite/Developing_Layouts1/Responsive_Coding_Pratice_8.js";
import Responsive_Coding_Pratice_9 from "../ResponsiveWebsite/Developing_Layouts1/Responsive_Coding_Pratice_9.js";
import Responsive_Coding_Pratice_10 from "../ResponsiveWebsite/Developing_Layouts2/Responsive_Coding_Pratice_10.js";
import Responsive_Coding_Pratice_11 from "../ResponsiveWebsite/Developing_Layouts2/Responsive_Coding_Pratice_11.js";
import Responsive_Coding_Pratice_12 from "../ResponsiveWebsite/Developing_Layouts2/Responsive_Coding_Pratice_12.js";
import Responsive_Coding_Pratice_13 from "../ResponsiveWebsite/Developing_Layouts2/Responsive_Coding_Pratice_13.js";
import Responsive_Coding_Pratice_14 from "../ResponsiveWebsite/Developing_Layouts_Pratice/Responsive_Coding_Pratice_14.js";
import Responsive_Coding_Pratice_15 from "../ResponsiveWebsite/Developing_Layouts_Pratice/Responsive_Coding_Pratice_15.js";
import Responsive_Coding_Pratice_16 from "../ResponsiveWebsite/Developing_Layouts_Pratice/Responsive_Coding_Pratice_16.js";
import Responsive_Coding_Assignment_1 from "../ResponsiveWebsite/Assignments/Responsive_Coding_Assignment_1.js";
import Responsive_Coding_Assignment_2 from "../ResponsiveWebsite/Assignments/Responsive_Coding_Assignment_2.js";
import Responsive_Coding_Assignment_3 from "../ResponsiveWebsite/Assignments/Responsive_Coding_Assignment_3.js";
import Responsive_Coding_Test_1 from "../ResponsiveWebsite/Mock_Tests/Responsive_Coding_Test_1.js";
import Responsive_Coding_Test_2 from "../ResponsiveWebsite/Mock_Tests/Responsive_Coding_Test_2.js";
import Responsive_Coding_Test_3 from "../ResponsiveWebsite/Mock_Tests/Responsive_Coding_Test_3.js";
import Responsive_Project from "../ResponsiveWebsite/Mock_Tests/Responsive_Project.js";
import Responsive_Course_Exam_Instructions from "../ResponsiveWebsite/Responsive_Course_Exam/Responsive_Course_Exam_Instructions.js";
import Responsive_Course_Exam from "../ResponsiveWebsite/Responsive_Course_Exam/Responsive_Course_Exam.js";

//Python Coding & Class
import Coding_Pratice_Walkthough from "../Python/IntroductiontoPython/Coding_Pratice_Walkthough.js";
import Inp_Oup_Basics_Class from "../Python/Inp_Oup_Basiscs/Inp_Oup_Basics_Class.js";
import Type_Con_Class from "../Python/Inp_Oup_Basiscs/Type_Con_Class.js";
import Pro_W_P_Class from "../Python/IntroductiontoPython/Pro_W_P_Class.js";
import Seq_Of_Instruction_Class from "../Python/IntroductiontoPython/Seq_OF_Instruction_Class.js";
import Variables_DT_Class from "../Python/IntroductiontoPython/Variables_DT_Class.js";
import Coding_Practice_1 from "../Python/IntroductiontoPython/coding_Practice_1.js";
import Coding_Practice_2 from "../Python/IntroductiontoPython/coding_Practice_2.js";
import Coding_Practice_3 from "../Python/IntroductiontoPython/coding_Practice_3.js";
import Coding_Pratice_1A from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1A.js";
import Coding_Pratice_1B from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1B.js";
import Coding_Pratice_1C from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1C.js";
import Coding_Pratice_1D from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1D.js";
import Coding_Pratice_1E from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1E.js";
import Coding_Pratice_1F from "../Python/Inp_Oup_Basiscs/Coding_Pratice_1F.js";
import Assignment_1A from "../Python/Inp_Oup_Basiscs/Assignment_1A.js";
import Assignment_1B from "../Python/Inp_Oup_Basiscs/Assignment_1B.js";
import Relationoperator_Class from "../Python/Operators&ConditionalStmts/RelationOperator_Class.js";
import Logicaloperators_Class from "../Python/Operators&ConditionalStmts/LogicalOperators_Class.js";
import Conditionalstmts_Class from "../Python/Operators&ConditionalStmts/ConditionalStmts_Class.js";
import Coding_Pratice_2A from "../Python/Operators&ConditionalStmts/Coding_Pratice_2A.js";
import Coding_Pratice_2B from "../Python/Operators&ConditionalStmts/Coding_Pratice_2B.js";
import Assignment_2A from "../Python/Operators&ConditionalStmts/Assignment_2A.js";
import Coding_Pratice_2C from "../Python/Operators&ConditionalStmts/Coding_Pratice_2C.js";
import Coding_Pratice_2D from "../Python/Operators&ConditionalStmts/Coding_Pratice_2D.js";
import Coding_Pratice_2E from "../Python/Operators&ConditionalStmts/Coding_Pratice_2E.js";
import Assignment_2B from "../Python/Operators&ConditionalStmts/Assignment_2B.js";
import Coding_Pratice_3A from "../Python/Operators&ConditionalStmts/Coding_Pratice_3A.js";
import Coding_Pratice_3B from "../Python/Operators&ConditionalStmts/Coding_Pratice_3B.js";
import Assignment_3A from "../Python/Operators&ConditionalStmts/Assignment_3A.js";
import ProblemSol_Debugging_Class_1 from "../Python/NestedConditions/ProblemSol_Debugging_Class_1.js";
import ProblemSol_Debugging_Class_2 from "../Python/NestedConditions/ProblemSol_Debugging_Class_2.js";
import Nested_con_Class from "../Python/NestedConditions/Nested_con_Class.js";
import Coding_Pratice_4A from "../Python/NestedConditions/Coding_Pratice_4A.js";
import Coding_Pratice_4B from "../Python/NestedConditions/Coding_Pratice_4B.js";
import Assignment_4 from "../Python/NestedConditions/Assignment_4.js";
// import Python_Coding_Pratice_5 from "../Python/NestedConditions/Python_Coding_Pratice_5.js";
import Assignment_5 from "../Python/NestedConditions/Assignment_5.js";
import Coding_Pratice_6A from "../Python/NestedConditions/Coding_Pratice_6A.js";
import Coding_Pratice_6B from "../Python/NestedConditions/Coding_Pratice_6B.js";
import Assignment_6 from "../Python/NestedConditions/Assignment_6.js";
import Grand_Assignment_1 from "../Python/NestedConditions/Grand_Assignment_1.js";
import Loops_Class from "../Python/Loops/Loops_Class.js";
import FoorLoop_Class from "../Python/Loops/ForLoop_Class.js";
import Problem_Solving_Part_1_Class from "../Python/NestedConditions/Problem_Solving_Part_1_Class.js";
import Problem_Solving_Part_2_Class from "../Python/Loops/Problem_Solving_Part_2_Class.js";
import Problem_Solving_Part_3_Class from "../Python/Loops/Problem_Solving_Part_3_Class.js";
import Problem_Solving_Part_4_Class from "../Python/Loops/Problem_Solving_Part_4_Class.js";
import String_Methods_Class from "../Python/Loops/String_Methods_Class.js";
import Assignment_7 from "../Python/Loops/Assignment_7.js";
import Assignment_8 from "../Python/Loops/Assignment_8.js";
import Assignment_9 from "../Python/Loops/Assignment_9.js";
import Assignment_10A from "../Python/Loops/Assignment_10A.js";
import Assignment_10B from "../Python/Loops/Assignment_10B.js";
import Assignment_11 from "../Python/Loops/Assignment_11.js";
import Coding_Pratice_7A from "../Python/Loops/Coding_Pratice_7A.js";
import Coding_Pratice_7B from "../Python/Loops/Coding_Pratice_7B.js";
import Coding_Pratice_8A from "../Python/Loops/Coding_Pratice_8A.js";
import Coding_Pratice_8B from "../Python/Loops/Coding_Pratice_8B.js";
import Coding_Pratice_9A from "../Python/Loops/Coding_Pratice_9A.js";
import Coding_Pratice_9B from "../Python/Loops/Coding_Pratice_9B.js";
import Coding_Pratice_10A from "../Python/Loops/Coding_Pratice_10A.js";
import Coding_Pratice_10B from "../Python/Loops/Coding_Pratice_10B.js";
import Coding_Pratice_10C from "../Python/Loops/Coding_Pratice_10C.js";
import Coding_Pratice_10D from "../Python/Loops/Coding_Pratice_10D.js";
import Coding_Pratice_10E from "../Python/Loops/Coding_Pratice_10E.js";
import Coding_Pratice_10F from "../Python/Loops/Coding_Pratice_10F.js";
import Coding_Pratice_11A from "../Python/Loops/Coding_Pratice_11A.js";
import Coding_Pratice_11B from "../Python/Loops/Coding_Pratice_11B.js";
import Fundations_Exam_1 from "../Python/Loops/Fundations_Exam_1.js";
import NestedLoops_Class from "../Python/LoopContronStmts/NestedLoops_Class.js";
import LoopControlStmts_Class from "../Python/LoopContronStmts/LoopControlStmts_Class.js";
import Assignment_12 from "../Python/LoopContronStmts/Assignment_12.js";
import Assignment_13 from "../Python/LoopContronStmts/Assignment_13.js";
import Assignment_14 from "../Python/LoopContronStmts/Assignment_14.js";
import Assignment_16 from "../Python/LoopContronStmts/Assignment_16.js";
import Coding_Pratice_12 from "../Python/LoopContronStmts/Coding_Pratice_12.js";
import Coding_Pratice_13A from "../Python/LoopContronStmts/Coding_Pratice_13A.js";
import Coding_Pratice_13B from "../Python/LoopContronStmts/Coding_Pratice_13B.js";
import Coding_Pratice_14A from "../Python/LoopContronStmts/Coding_Pratice_14A.js";
import Coding_Pratice_14B from "../Python/LoopContronStmts/Coding_Pratice_14B.js";
import Coding_Pratice_15A from "../Python/LoopContronStmts/Coding_Pratice_15A.js";
import Coding_Pratice_15B from "../Python/LoopContronStmts/Coding_Pratice_15B.js";
import Coding_Pratice_16 from "../Python/LoopContronStmts/Coding_Pratice_16.js";
import Problem_Solving_Part_5_Class from "../Python/LoopContronStmts/Problem_Solving_Part_5_Class.js";
import Problem_Solving_Part_6_Class from "../Python/LoopContronStmts/Problem_Solving_Part_6_Class.js";
import Problem_Solving_Part_7_Class from "../Python/LoopContronStmts/Problem_Solving_Part_7_Class.js";
import ProblemSol_Debugging_Class_3 from "../Python/LoopContronStmts/ProblemSol_Debugging_Class_3.js";
import Grand_Assignment_2 from "../Python/LoopContronStmts/Grand_Assignment_2.js";
import List_Class from "../Python/Lists/List_Class.js";
import Workingwith_List_Class from "../Python/Lists/Workingwith_List_Class.js";
import Coding_Pratice_20 from "../Python/Lists/Coding_Pratice_20.js";
import Assignment_20 from "../Python/Lists/Assignment_20.js";
import ComparigStr_NamingVar_Class from "../Python/ComparingStr&NamingVar/ComparingStr_NamingVar_Class.js";
import ProblemSol_Debugging_Class_4 from "../Python/ComparingStr&NamingVar/ProblemSol_Debugging_Class_4.js";
import ProblemSol_Debugging_Class_5 from "../Python/ComparingStr&NamingVar/ProblemSol_Debugging_Class_5.js";
import Coding_Pratice_17A from "../Python/ComparingStr&NamingVar/Coding_Pratice_17A.js";
import Coding_Pratice_17B from "../Python/ComparingStr&NamingVar/Coding_Pratice_17B.js";
import Coding_Pratice_18 from "../Python/ComparingStr&NamingVar/Coding_Pratice_18.js";
import Coding_Pratice_19 from "../Python/ComparingStr&NamingVar/Coding_Pratice_19.js";
import Assignment_17 from "../Python/ComparingStr&NamingVar/Assignment_17.js";
import Assignment_18 from "../Python/ComparingStr&NamingVar/Assignment_18.js";
import Assignment_19 from "../Python/ComparingStr&NamingVar/Assignment_19.js";
import Function_Argu_Class from "../Python/Functions/Function_Argu_Class.js";
import Functions_Class from "../Python/Functions/Functions_Class.js";
import Lists_String_Class from "../Python/Functions/Lists_String_Class.js";
import Assignment_21 from "../Python/Functions/Assignment_21.js";
import Assignment_22 from "../Python/Functions/Assignment_22.js";
import Assignment_23 from "../Python/Functions/Assignment_23.js";
import Coding_Pratice_21A from "../Python/Functions/Coding_Pratice_21A.js";
import Coding_Pratice_21B from "../Python/Functions/Coding_Pratice_21B.js";
import Coding_Pratice_22A from "../Python/Functions/Coding_Pratice_22A.js";
import Coding_Pratice_22B from "../Python/Functions/Coding_Pratice_22B.js";
import Coding_Pratice_23A from "../Python/Functions/Coding_Pratice_23A.js";
import Coding_Pratice_23B from "../Python/Functions/Coding_Pratice_23B.js";
import Fundations_Exam_2 from "../Python/Functions/Foundations_Exam_2.js";
import Built_in_Fun_Class from "../Python/Recursion/Built_in_Fun_Class.js";
import FunCallStack_Recursion_Class from "../Python/Recursion/FunCallStack_Recursion_Class.js";
import ListMethods_Class from "../Python/Recursion/ListMethods_Class.js";
import Coding_Pratice_24 from "../Python/Recursion/Coding_Pratice_24.js";
import Coding_Pratice_25 from "../Python/Recursion/Coding_Pratice_25.js";
import Coding_Pratice_26 from "../Python/Recursion/Coding_Pratice_26.js";
import Assignment_24 from "../Python/Recursion/Assignment_24.js";
import Assignment_25 from "../Python/Recursion/Assignment_25.js";
import Assignment_26 from "../Python/Recursion/Assignment_26.js";
import Tuples_Sequences_Class from "../Python/Tuples&Sets/Tuples_Sequences_Class.js";
import Sets_Class from "../Python/Tuples&Sets/Sets_Class.js";
import Set_Operations_Class from "../Python/Tuples&Sets/Set_Operations_Class.js";
import Coding_Pratice_27 from "../Python/Tuples&Sets/Coding_Pratice_27.js";
import ProblemSol_Debugging_Class_6 from "../Python/Dictionaries/ProblemSol_Debugging_Class_6.js";
import ProblemSol_Debugging_Class_7 from "../Python/Dictionaries/ProblemSol_Debugging_Class_7.js";
import Coding_Pratice_28 from "../Python/Dictionaries/Coding_Pratice_28.js";
import Coding_Pratice_29 from "../Python/Dictionaries/Coding_Pratice_29.js";
import Coding_Pratice_30 from "../Python/Dictionaries/Coding_Pratice_30.js";
import Coding_Pratice_31 from "../Python/Dictionaries/Coding_Pratice_31.js";
import NestedList_StringFormating_Class from "../Python/Dictionaries/NestedList_StringFormating_Class.js";
import Dictionaries_Class from "../Python/Dictionaries/Dictionaries_Class.js";
import Working_With_Dictionaries_Class from "../Python/Dictionaries/Working_With_Dictionaries_Class.js";
import Grand_Assignment_3 from "../Python/Dictionaries/Grand_Assignment_3.js";
import Grand_Assignment_4 from "../Python/Dictionaries/Grand_Assignment_4.js";
import Foundations_Exam_3 from "../Python/Dictionaries/Foundations_Exam_3.js";
import Introductionto_OPP_Part_1_Class from "../Python/IntroductiontoOOP/Introductionto_OPP_Part_1_Class.js";
import Introductionto_OPP_Part_2_Class from "../Python/IntroductiontoOOP/Introductionto_OPP_Part_2_Class.js";
import Classes_Object_Class from "../Python/IntroductiontoOOP/Classes_Object_Class.js";
import Attributes_Methods_Class from "../Python/IntroductiontoOOP/Attributes_Methods_Class.js";
import Inheritance_Part_1_Class from "../Python/IntroductiontoOOP/Inheritance_Part_1_Class.js";
import Inheritance_Part_2_Class from "../Python/IntroductiontoOOP/Inheritance_Part_2_Class.js";
import Coding_Pratice_32 from "../Python/IntroductiontoOOP/Coding_Pratice_32.js";
import Coding_Pratice_33 from "../Python/IntroductiontoOOP/Coding_Pratice_33.js";
import OPP_On_Demand_Session from "../Python/IntroductiontoOOP/OPP_On_Demand_Session.js";
import Python_Standard_Library_Class from "../Python/Miscellaneous/Python_Standard_Library_Class.js";
import Scope_Namespaces_Class from "../Python/Miscellaneous/Scope_Namespaces_Class.js";
import Errors_Exceptions_Class from "../Python/Miscellaneous/Errors_Exceptions_Class.js";
import Dates_Time_Class from "../Python/Miscellaneous/Dates_Time_Class.js";
import Workingwith_Data_Time_Class from "../Python/Miscellaneous/Workingwith_Data_Time_Class.js";
import Coding_Pratice_34 from "../Python/Miscellaneous/Coding_Pratice_34.js";
import Grand_Assignment_5 from "../Python/Miscellaneous/Grand_Assignment_5.js";
import Programmig_Foundations_Course_Exam_Instructions_Class from "../Python/Programmig_Foundations_Course_Exam/Programmig_Foundations_Course_Exam_Instructions_Class.js";
import Programmig_Foundations_Course_Exam from "../Python/Programmig_Foundations_Course_Exam/Programmig_Foundations_Course_Exam.js";

//JavaScript Classes
import Dom_Event_Fundamentals_Class from "../JavaScript/Introductionto_Js_Variables/DOM_Event_Fundamentals_Class.js";
import Introductionto_Dynamic_Application_Class from "../JavaScript/Introductionto_Js_Variables/Introductionto_Dynamic_Application_Class.js";
import PrimitiveTypes_Conditionals_Class from "../JavaScript/Introductionto_Js_Variables/PrimitiveTypes_Conditionals_Class.js";
import InputEle_Mathfunctions_Class from "../JavaScript/Introductionto_Js_Variables/InputEle_MathFunctions_Class.js";
import Coding_Pratice_1 from "../JavaScript/Introductionto_Js_Variables/Coding_Pratice_1.js";
import Coding_Pratice_2 from "../JavaScript/Introductionto_Js_Variables/Coding_Pratice_2.js";
import Coding_Pratice_3 from "../JavaScript/Introductionto_Js_Variables/Coding_Pratice_3.js";
import Arrays_Dom_Manipulations_Class from "../JavaScript/Arrays_Objects/Arrays_Dom_Manipulations_Class.js";
import JS_Coding_Pratice_Walkthrough from "../JavaScript/Arrays_Objects/JS_Coding_Pratice_Walkthrough.js";
import Objects_Class from "../JavaScript/Arrays_Objects/Objects_Class.js";
import Comments from "../JavaScript/Arrays_Objects/Comments.js";
import A_Note_ON_Software_Capability from "../JavaScript/Arrays_Objects/A_Note_ON_Software_Capability.js";
import Coding_Pratice_4 from "../JavaScript/Arrays_Objects/Coding_Pratice_4.js";
import Coding_Pratice_JS_5 from "../JavaScript/Arrays_Objects/Coding_Pratice_JS_5.js";
import Coding_Pratice_6 from "../JavaScript/Todos_Application/Coding_Pratice_6.js";
import Coding_Pratice_7 from "../JavaScript/Todos_Application/Coding_Pratice_7.js";
import Coding_Pratice_8 from "../JavaScript/Todos_Application/Coding_Pratice_8.js";
import JS_Coding_Pratic_1 from "../JavaScript/Arrays_Objects/JS_Coding_Pratic_1.js";
import JS_Coding_Pratic_2 from "../JavaScript/Arrays_Objects/JS_Coding_Pratic_2.js";
import JS_Coding_Pratic_3 from "../JavaScript/Arrays_Objects/JS_Coding_Pratic_3.js";
import JS_Coding_Pratic_4 from "../JavaScript/Arrays_Objects/JS_Coding_Pratic_4.js";
import Todos_Application_Introduction from "../JavaScript/Todos_Application/Todos_Application_Introduction.js";
import Todos_Application_Part_1_Class from "../JavaScript/Todos_Application/Todos_Application_Part_1_Class.js";
import Todos_Application_Part_2_Class from "../JavaScript/Todos_Application/Todos_Application_Part_2_Class.js";
import JavaScript_On_Demand_Session_Class from "../JavaScript/Todos_Application/JavaScript_On_Demand_Session_Class.js";
import Todos_Application_Part_3_Class from "../JavaScript/Todos_Application_2/Todos_Application_Part_3_Class.js";
import Todos_Application_Part_4_Class from "../JavaScript/Todos_Application_2/Todos_Application_Part_4_Class.js";
import Coding_Pratice_9 from "../JavaScript/Todos_Application_2/Coding_Pratice_9.js";
import Coding_Pratice_10 from "../JavaScript/Todos_Application_2/Coding_Pratice_10.js";
import Coding_Pratice_11 from "../JavaScript/Todos_Application_3/Coding_Pratice_11.js";
import JS_Coding_Pratic_5 from "../JavaScript/Todos_Application/JS_Coding_Pratic_5.js";
import JS_Coding_Pratice_6 from "../JavaScript/Todos_Application_3/JS_Coding_Pratice_6.js";
import JS_Coding_Pratice_7 from "../JavaScript/Todos_Application_3/JS_Coding_Pratice_7.js";
import Todos_Application_Part_5_Class from "../JavaScript/Todos_Application_3/Todos_Application_Part_5_Class.js";
import Array_Methods_Pratice_1 from "../JavaScript/Todos_Application_3/Array_Methods_Pratice_1.js";
import Array_Methods_Pratice_2 from "../JavaScript/Todos_Application_3/Array_Methods_Pratice_2.js";
import Array_Methods_Pratice_3 from "../JavaScript/Todos_Application_3/Array_Methods_Pratice_3.js";
import Todos_Application_Part_6_Class from "../JavaScript/Todos_Application_4/Todos_Application_Part_6_Class.js";
import Coding_Pratice_JS_12 from "../JavaScript/Todos_Application_4/Coding_Pratice_JS_12.js";
import Coding_Pratice_13 from "../JavaScript/Todos_Application_4/Coding_Pratice_13.js";
import Callbacks_Schedulers_Class from "../JavaScript/Fetch_Callbacks/Callbacks_Schedulers_Class.js";
import Event_Listners_More_Events_Class from "../JavaScript/Fetch_Callbacks/Event_Listners_More_Events_Class.js";
import Hypertext_Transfer_Protocal_Class from "../JavaScript/Fetch_Callbacks/Hypertext_Transfer_Protocal_Class.js";
import Coding_Pratice_14 from "../JavaScript/Fetch_Callbacks/Coding_Pratice_14.js";
import Coding_Pratice_15 from "../JavaScript/Fetch_Callbacks/Coding_Pratice_15.js";
import JS_Coding_Assignment_1 from "../JavaScript/Fetch_Callbacks/JS_Coding_Assignment_1.js";
import HTTP_Request_Using_Class from "../JavaScript/Fetch_Callbacks_2/HTTP_Request_Using_Class.js";
import Wikipedia_Search_Class from "../JavaScript/Fetch_Callbacks_2/Wikipedia_Search_Class.js";
import Coding_Pratice_JS_16 from "../JavaScript/Fetch_Callbacks_2/Coding_Pratice_JS_16.js";
import Coding_Pratice_17 from "../JavaScript/Fetch_Callbacks_2/Coding_Pratice_17.js";
import Coding_Pratice_JS_18 from "../JavaScript/Fetch_Callbacks_2/Coding_Pratice_JS_18.js";
import Coding_Pratice_JS_19 from "../JavaScript/Forms/Coding_Pratice_JS_19.js";
import Coding_Pratice_JS_20 from "../JavaScript/Forms/Coding_Pratice_JS_20.js";
import Forms_Part_1_Class from "../JavaScript/Forms/Forms_Part_1_Class.js";
import Forms_Part_2_Class from "../JavaScript/Forms/Forms_Part_2_Class.js";
import JS_Coding_Assignment_2 from "../JavaScript/Assignment/JS_Coding_Assignment_2.js";
import JS_Coding_Assignment_3 from "../JavaScript/Assignment/JS_Coding_Assignment_3.js";
import Coding_Test_1 from "../JavaScript/Mock_Test/Coding_Test_1.js";
import Coding_Test_2 from "../JavaScript/Mock_Test/Coding_Test_2.js";
import Coding_Test_3 from "../JavaScript/Mock_Test/Coding_Test_3.js";
import Coding_Test_4 from "../JavaScript/Mock_Test/Coding_Test_4.js";
import JS_Coding_Test_1 from "../JavaScript/Mock_Test/JS_Coding_Test_1.js";
import JS_Coding_Test_2 from "../JavaScript/Mock_Test/JS_Coding_Test_2.js";
import MCQ_Test_1 from "../JavaScript/Mock_Test/JS_MCQ_Test_1.js";
import MCQ_Test_2 from "../JavaScript/Mock_Test/JS_MCQ_Test_2.js";
import Dynamic_Course_Exam_Instructions_Class from "../JavaScript/Dynamic_Course_Exam/Dynamic_Course_Exam_Instructions_Class.js";
import Dynamic_Course_Exam from "../JavaScript/Dynamic_Course_Exam/Dynamic_Course_Exam.js";


//JavaSript Cheat Sheet
import Introductionto_Dynamic_Application_CS from "../JavaScript/Introductionto_Js_Variables/Introductionto_Dynamic_Application_CS.js";
import DOM_Event_Fundamentals_CS from "../JavaScript/Introductionto_Js_Variables/DOM_Event_Fundamentals_CS.js";
import Primitive_Types_Conditionals_CS from "../JavaScript/Introductionto_Js_Variables/PrimitiveTypes_Conditionals_CS.js";
import InputEle_MathFunctions_CS from "../JavaScript/Introductionto_Js_Variables/InputEle_MathFunctions_CS.js";
import Arrays_Dom_Manipulations_CS from "../JavaScript/Arrays_Objects/Arrays_Dom_Manipulations_CS.js";
import Objects_CS from "../JavaScript/Arrays_Objects/Objects_CS.js";
import Todos_Applications_CS from "../JavaScript/Todos_Application/Todos_Applications_CS.js";
import JavaScript_On_Demand_Session_CS from "../JavaScript/Todos_Application/JavaScript_On_Demand_Session_CS.js";
import Todos_Application_CS_2 from "../JavaScript/Todos_Application/Todos_Application_CS_2.js";
import Todos_Application_CS_3 from "../JavaScript/Todos_Application_2/Todos_Application_CS_3.js";
import Todos_Application_CS_4 from "../JavaScript/Todos_Application_2/Todos_Application_CS_4.js";
import Todos_Application_CS_5 from "../JavaScript/Todos_Application_3/Todos_Application_CS_5.js";
import Todos_Application_CS_6 from "../JavaScript/Todos_Application_4/Todos_Application_CS_6.js";
import Callbacks_Schedulers_CS from "../JavaScript/Fetch_Callbacks/Callbacks_Schedulers_CS.js";
import Event_Listners_More_Events_CS from "../JavaScript/Fetch_Callbacks/Event_Listners_More_Events_CS.js";
import HTTP_Request_Using_JS_CS from "../JavaScript/Fetch_Callbacks_2/HTTP_Request_Using_JS_CS.js";
import Hypertext_Transfer_Protocal_CS from "../JavaScript/Fetch_Callbacks/Hypertext_Transfer_Protocal_CS.js";
import Wikipedia_Search_CS from "../JavaScript/Fetch_Callbacks_2/Wikipedia_Search_CS.js";
import Forms_CS from "../JavaScript/Forms/Forms_CS.js";
import Forms_CS_2 from "../JavaScript/Forms/Forms_CS_2.js";

// SQL DataBase
import Introductionto_Database_1 from "../SQL_Database/Introduction/Introductionto_Database_1.js";
import Introductionto_Database_2 from "../SQL_Database/Introduction/Introductionto_Database_2.js";
import Introductionto_Database_MCQ from "../SQL_Database/Introduction/Introductionto_Database_MCQ.js";
import Introduction_to_Databases_CS from "../SQL_Database/Introduction/Introduction_to_Databases_CS.js";
import Introductionto_SQL_1 from "../SQL_Database/Introdutionto_SQL/Introductionto_SQL_1.js";
import Introductionto_SQL_2 from "../SQL_Database/Introdutionto_SQL/Introductionto_SQL_2.js";
import SQL_Platform_Walkthrough from "../SQL_Database/Introdutionto_SQL/SQL_Platform_Walkthrough.js";
import Create_Table_CS from "../SQL_Database/Introdutionto_SQL/Create_Table_CS.js";
import Inserting_Row_CS from "../SQL_Database/Introdutionto_SQL/Inserting_Row_CS.js";
import Retrieving_Data_CS from "../SQL_Database/Introdutionto_SQL/Retrieving_Data_CS.js";
import Update_Rows_CS from "../SQL_Database/Introdutionto_SQL/Update_Rows_CS.js";
import Delete_Rows_CS from "../SQL_Database/Introdutionto_SQL/Delete_Rows_CS.js";
import Alter_Table_CS from "../SQL_Database/Introdutionto_SQL/Alert_Table_CS.js";
import Introductionto_SQL_MCQ_1 from "../SQL_Database/Introdutionto_SQL/Introductionto_SQL_MCQ_1.js";
import Introductionto_SQL_MCQ_2 from "../SQL_Database/Introdutionto_SQL/Introductionto_SQL_MCQ_2.js";
import Comparison_Operators_CS from "../SQL_Database/Quering_SQL/Comparision_Opeartors_CS.js";
import String_Operators_CS from "../SQL_Database/Quering_SQL/String_Operators_CS.js";
import Logical_Operators_CS from "../SQL_Database/Quering_SQL/Logical_Operators_CS.js";
import Common_Mistakes_RM_CS from "../SQL_Database/Introdutionto_SQL/Common_Mistakes_RM_CS.js";
import Common_Mistakes_RM_MCQ from "../SQL_Database/Introdutionto_SQL/Common_Mistakes_RM_MCQ.js";
import Quering_SQL_1 from "../SQL_Database/Quering_SQL/Quering_SQL_1.js";
import Quering_SQL_2 from "../SQL_Database/Quering_SQL/Quering_SQL_2.js";
import Quering_SQL_3 from "../SQL_Database/Quering_SQL/Quering_SQL_3.js";
import Quering_SQL_MCQ_1 from "../SQL_Database/Quering_SQL/Quering_SQL_MCQ_1.js";
import Quering_SQL_MCQ_2 from "../SQL_Database/Quering_SQL/Quering_SQL_MCQ_2.js";
import Quering_SQL_MCQ_3 from "../SQL_Database/Quering_SQL/Quering_SQL_MCQ_3.js";
import In_Between_Operators_CS from "../SQL_Database/Quering_SQL/In_Between_Operators_CS.js";
import Order_By_Distinct_CS from "../SQL_Database/Quering_SQL/Order_By_Distinct_CS_.js";
import Pagination_CS from "../SQL_Database/Quering_SQL/Pagination_CS.js";
import Aggregations from "../SQL_Database/Aggregations/Aggregations.js";
import Aggregations_CS from "../SQL_Database/Aggregations/Aggregations_CS.js";
import Aggregations_MCQ from "../SQL_Database/Aggregations/Aggregations_MCQ.js";
import Group_By from "../SQL_Database/Aggregations/Group_By.js";
import Group_By_Having from "../SQL_Database/Aggregations/Group_By_Having.js";
import Group_By_Having_CS from "../SQL_Database/Aggregations/Group_By_Having_CS.js";
import Groupby_Having_MCQ from "../SQL_Database/Aggregations/Groupby_Having_MCQ.js";
import Common_Concepts_Class from "../SQL_Database/Common_Concepts/Common_Concepts_Class.js";
import Common_Concepte_MCQ from "../SQL_Database/Common_Concepts/Common_Concepte_MCQ.js";
import SQL_Expression_Cs from "../SQL_Database/Common_Concepts/SQL_Expression_CS.js";
import SQL_Functions_CS from "../SQL_Database/Common_Concepts/SQL_Functions_CS.js";
import Cast_Functions_CS from "../SQL_Database/Common_Concepts/Cast_Functions_CS.js";
import Arthmetic_Functions_CS from "../SQL_Database/Common_Concepts/Arthmetic_Functions_CS.js";
import SQL_Case_CS from "../SQL_Database/Common_Concepts/SQL_Case_CS.js";
import SQL_Set_Operations_CS from "../SQL_Database/Common_Concepts/SQL_Set_Operations_CS.js";
// import Coding_Pratice_5 from "../SQL_Database/Common_Concepts/Coding_Pratice_5.js";
import Milestone_CS from "../SQL_Database/MileStone/MileStone_CS.js";
import Milestone_MCQ from "../SQL_Database/MileStone/MileStone_MCQ.js";
import SQL_Assignment_1 from "../SQL_Database/MileStone/SQL_Assignment_1.js";
import SQL_Assignment_2 from "../SQL_Database/MileStone/SQL_Assignment_2.js";
import Applying_ER_Model_Concepts_CS from "../SQL_Database/Modelling_Databases/Applying_ER_Model_Concepts_CS.js";
import Core_Concepts_ER_CS from "../SQL_Database/Modelling_Databases/Core_Concepts_ER_CS.js";
import Creating_Relation_DB_CS from "../SQL_Database/Modelling_Databases/Creating_Relation_DB_CS.js";
import ER_Model_Relational_DB from "../SQL_Database/Modelling_Databases/ER_Model_Relational_DB.js";
import Modelling_Database_Class_1 from "../SQL_Database/Modelling_Databases/Modelling_Database_Class_1.js";
import Modelling_Database_Class_2 from "../SQL_Database/Modelling_Databases/Modelling_Database_Class_2.js";
import Modelling_Database_MCQ from "../SQL_Database/Modelling_Databases/Modelling_Database_MCQ.js";
import Creating_Relational_DB_MCQ from "../SQL_Database/Modelling_Databases/Creating_Relational_DB_MCQ.js";
import Joins_Class_Part_1 from "../SQL_Database/Joins/Joins_Class_Part_1.js";
import Joins_Part_1_Cs from "../SQL_Database/Joins/Joins_Part_1_CS.js";
import Joins_MCQ from "../SQL_Database/Joins/Joins_MCQ.js";
import Quering_with_Joins_Class_Part_2 from "../SQL_Database/Joins/Quering_with_Joins_Class_Part_2.js";
import Quering_with_Joins_CS_Part_2 from "../SQL_Database/Joins/Quering_with_Joins_CS_Part_2.js";
import Quering_with_Joins_Part_2_MCQ from "../SQL_Database/Joins/Quering_with_Joins_Part_2_MCQ.js";
import Quering_with_Joins_Class_Part_3 from "../SQL_Database/Joins/Quering_with_Joins_Class_Part_3.js";
import Quering_with_Joins_CS_Part_3 from "../SQL_Database/Joins/Quering_with_Joins_CS_Part_3.js";
import Quering_with_Joins_MCQ_Part_3 from "../SQL_Database/Joins/Quering_with_Joins_MCQ_Part_3.js";
import Joins_Coding_Pratice_1 from "../SQL_Database/Joins/Joins_Coding_Pratice_1.js";
import Joins_Coding_Pratice_2 from "../SQL_Database/Joins/Joins_Coding_Pratice_2.js";
import Joins_Coding_Pratice_3 from "../SQL_Database/Joins/Joins_Coding_Pratice_3.js";
import Joins_Coding_Pratice_4 from "../SQL_Database/Joins/Joins_Coding_Pratice_4.js";
import Views_And_Subqueries from "../SQL_Database/Views_Subqueries/Views_And_Subqueries.js";
import Views_And_Subqueries_CS from "../SQL_Database/Views_Subqueries/Views_And_Subqueries_CS.js";
import Subqueries_CS from "../SQL_Database/Views_Subqueries/Subqueries_CS.js";
import Views_And_Subqueries_MCQ from "../SQL_Database/Views_Subqueries/Views_And_Subqueries_MCQ.js";
import View_Subqeries_Coding_Pratice_11 from "../SQL_Database/Views_Subqueries/View_Subqeries_Coding_Pratice_11.js";
import Transaction_Indexes_Class from "../SQL_Database/Transaction_Indexes/Transaction_Indexes_Class.js";
import Transaction_Indexes_CS from "../SQL_Database/Transaction_Indexes/Transaction_Indexes_CS.js";
import Transaction_Indexes_MCQ from "../SQL_Database/Transaction_Indexes/Transaction_Indexes_MCQ.js";
import SQL_Syntax_Differences from "../SQL_Database/SQL_Syntax_Differences/SQL_Syntax_Differences.js";
import SQL_Assignment_3 from "../SQL_Database/MileStone_2/SQL_Assignment_3.js";
import MCQ_Exam_1 from "../SQL_Database/MileStone_2/MCQ_Exam_1.js";

//Static Website MCQs
import Introductionto_HTML_MCQ from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_HTML_MCQ.js";
import Introductionto_Css_BoxModel_MCQ_1 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_MCQ_1.js";
import Introductionto_Css_MCQ_1 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_MCQ_1.js";
import Introductionto_Css_MCQ_2 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_MCQ_2.js";
import Introductionto_Css_MCQ_3 from "../StaticWebsite/Introductionto_HTML_CSS/Introductionto_Css_MCQ_3.js";
import Introductionto_Css_BoxModel_MCQ_2 from "../StaticWebsite/Css_BoxModel/Introductionto_Css_BoxModel_MCQ_2.js";
import Introductionto_BootStrap_MCQ_1 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_MCQ_1.js";
import Introductionto_BootStrap_MCQ_2 from "../StaticWebsite/BootStrap/Introductionto_BootStrap_MCQ_2.js";
import FavouritePlaces_Section_MCQ_1 from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_Section_MCQ_1.js";
import Approachto_Develop_Layout_MCQ_2 from "../StaticWebsite/DevelopingLayouts/Approachto_Develop_Layout_MCQ_2.js";
import FavouritePlaces_DetailedView_MCQ_3 from "../StaticWebsite/DevelopingLayouts/FavouritePlaces_DetailView_MCQ_3.js";
import Website_Integration_MCQ_1 from "../StaticWebsite/WebSiteIntegration/Website_Integration_MCQ_1.js";
import Website_Integration_MCQ_2 from "../StaticWebsite/WebSiteIntegration/Website_Integration_MCQ_2.js";
import HTML_HyperLinks_MCQ from "../StaticWebsite/WebSiteIntegration/HTML_HyperLinks_MCQ.js";
import OnDemand_Session_MCQ from "../StaticWebsite/WebSiteIntegration/OnDemand_Session_MCQ.js";
import Static_MCQ_Assignment1 from "../StaticWebsite/Assignments/Static_MCQ_Assignment1.js";
import Static_MCQ_Assignment2 from "../StaticWebsite/Assignments/Static_MCQ_Assignment2.js";
import Static_MCQ_Assignment3 from "../StaticWebsite/Assignments/Static_MCQ_Assignment3.js";
import Static_MCQ_Assignment4 from "../StaticWebsite/Assignments/Static_MCQ_Assignment4.js";
import Introductionto_Responsive_WD_MCQ from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Introductionto_Responsive_WD_MCQ.js";
import Bootstrap_Grid_Sys_MCQ_1 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_MCQ_1.js";
import Bootstrap_Grid_Sys_MCQ_2 from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Grid_Sys_MCQ_2.js";
import Bootstrap_Navbar_MCQ from "../ResponsiveWebsite/Responsive_WD_BS_Grid_Sys/Bootstrap_Navbar_MCQ.js";
import Css_Selector_Inheritance_MCQ from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Selector_Inheritance_MCQ.js";
import Css_Specificity_Cascade_MCQ from "../ResponsiveWebsite/CSS_Building_Blocks/Css_Specificity_Cascade_MCQ.js";
import Banner_Section_MCQ from "../ResponsiveWebsite/Developing_Layouts1/Banner_Section_MCQ.js";
import Why_Chooseus_Section_MCQ from "../ResponsiveWebsite/Developing_Layouts1/Why_Chooseus_Section_MCQ.js";
import Explore_Menu_Section_MCQ from "../ResponsiveWebsite/Developing_Layouts1/Explore_Menu_Section_MCQ.js";
import Healthy_Delivary_Payments_MCQ from "../ResponsiveWebsite/Developing_Layouts1/Healthy_Delivary_Payments_MCQ.js";
import Followus_More_Styles_MCQ from "../ResponsiveWebsite/Developing_Layouts2/Followus_More_Styles_MCQ.js";
import CSS_Gradience_MCQ from "../ResponsiveWebsite/Developing_Layouts2/CSS_Gradience_MCQ.js";
import Responsive_MCQ_Assignments_1 from "../ResponsiveWebsite/Assignments/Responsive_MCQ_Assignments_1.js";
import Responsive_MCQ_Assignments_2 from "../ResponsiveWebsite/Assignments/Responsive_MCQ_Assignments_2.js";
import Responsive_MCQ_Assignments_3 from "../ResponsiveWebsite/Assignments/Responsive_MCQ_Assignments_3.js";

//Python MCQs
import Pro_W_P_MCQ from "../Python/IntroductiontoPython/Pro_W_P_MCQ.js";
import Variables_DT_MCQ from "../Python/IntroductiontoPython/Variables_DT_MCQ.js";
import Seq_OF_Instruction_MCQ from "../Python/IntroductiontoPython/Seq_OF_Instruction_MCQ.js";
import Inp_Oup_Basics_MCQ from "../Python/Inp_Oup_Basiscs/Inp_Oup_Basics_MCQ.js";
import Type_Con_MCQ from "../Python/Inp_Oup_Basiscs/Type_Con_MCQ.js";
import RelationOperator_MCQ from "../Python/Operators&ConditionalStmts/RelationOperator_MCQ.js";
import LogicalOperators_MCQ from "../Python/Operators&ConditionalStmts/LogicalOperators_MCQ.js";
import ConditionalStmts_MCQ from "../Python/Operators&ConditionalStmts/ConditionalStmts_MCQ.js";
import ProblemSol_Debugging_MCQ from "../Python/NestedConditions/ProblemSol_Debugging_MCQ.js";
import Nested_con_MCQ from "../Python/NestedConditions/Nested_con_MCQ.js";
import Loops_MCQ from "../Python/Loops/Loops_MCQ.js";
import ForLoop_MCQ from "../Python/Loops/ForLoop_MCQ.js";
import String_Methods_MCQ from "../Python/Loops/String_Methods_MCQ.js";
import Problem_sol_6_MCQ from "../Python/LoopContronStmts/Problem_sol_6_MCQ.js";
import Problem_sol_7_MCQ from "../Python/LoopContronStmts/Problem_sol_7_MCQ.js";
import LoopControlStmts_MCQ from "../Python/LoopContronStmts/LoopControlStmts_MCQ.js";
import ComparingStrAndNamingVar_MCQ from "../Python/ComparingStr&NamingVar/ComparingStrAndNamingVar_MCQ.js";
import List_MCQ from "../Python/Lists/List_MCQ.js";
import Workingwith_Lists_MCQ from "../Python/Lists/Workingwith_Lists_MCQ.js";
import Lists_String_MCQ from "../Python/Functions/Lists_String_MCQ.js";
import Functions_MCQ from "../Python/Functions/Functions_MCQ.js";
import Functions_Argu_MCQ from "../Python/Functions/Functions_Argu_MCQ.js";
import FunCallStack_Recursion_MCQ from "../Python/Recursion/FunCallStack_Recursion_MCQ.js";
import Built_in_Fun_MCQ from "../Python/Recursion/Built_in_Fun_MCQ.js";
import ListMethods_MCQ from "../Python/Recursion/ListMethods_MCQ.js";
import Tuples_Sequences_MCQ from "../Python/Tuples&Sets/Tuples_Sequences_MCQ.js";
import Sets_MCQ from "../Python/Tuples&Sets/Sets_MCQ.js";
import Set_Operations_MCQ from "../Python/Tuples&Sets/Set_Operations_MCQ.js";
import NestedList_Stringformating_MCQ from "../Python/Dictionaries/NestedList_StringFormating_MCQ.js";
import Dictionaries_MCQ from "../Python/Dictionaries/Dictionaries_MCQ.js";
import Working_With_Dictionaries_MCQ from "../Python/Dictionaries/Working_With_Dictionaries_MCQ.js";
import NestedLoops_MCQ from "../Python/LoopContronStmts/NestedLoops_MCQ.js";
import Introductionto_OOP1_MCQ from "../Python/IntroductiontoOOP/Introductionto_OPP1_MCQ.js";
import Introduction_Opp_MCQ2 from "../Python/IntroductiontoOOP/Introduction_Opp_MCQ2.js";
import Classes_Object_MCQ from "../Python/IntroductiontoOOP/Classes_Object_MCQ.js";
import Attributes_Methods_MCQ from "../Python/IntroductiontoOOP/Attributes_Methods_MCQ.js";
import Inheritance_Part1_MCQ from "../Python/IntroductiontoOOP/Inheritance_Part1_MCQ.js";
import Inheritance_Part2_MCQ from "../Python/IntroductiontoOOP/Inheritance_Part2_MCQ.js";
import Python_Standard_Library_MCQ from "../Python/Miscellaneous/Python_Standard_Library_MCQ.js";
import Scope_Namespaces_MCQ from "../Python/Miscellaneous/Scope_Namespaces__MCQ.js";
import Errors_Exceptions_MCQ from "../Python/Miscellaneous/Errors_Exceptions_MCQ";
import Dates_Time_MCQ from "../Python/Miscellaneous/Dates_Time_MCQ";
import Workingwith_Date_Time_MCQ from "../Python/Miscellaneous/Workingwith_Date_Time_MCQ";
import Introductionto_Dynamic_Application_MCQ from "../JavaScript/Introductionto_Js_Variables/Introductionto_Dynamic_Application_MCQ";
import Dom_Event_Fundamentals_MCQ from "../JavaScript/Introductionto_Js_Variables/Dom_Event_Fundamentals_MCQ";
import PrimitiveTypes_Conditionals_MCQ from "../JavaScript/Introductionto_Js_Variables/PrimitiveTypes_Conditionals_MCQ";
import Arrays_Dom_Manipulations_MCQ from "../JavaScript/Arrays_Objects/Arrays_Dom_Manipulations_MCQ";
import Objects_MCQ from "../JavaScript/Arrays_Objects/Objects_MCQ";
import Todos_Applications_MCQ from "../JavaScript/Todos_Application/Todos_Applications_MCQ";
import On_Demand_Session_MCQ from "../JavaScript/Todos_Application/JavaScript_On_Demand_Session_MCQ.js";
import Todos_Application_MCQ_2 from "../JavaScript/Todos_Application/Todos_Application_MCQ_2";
import Todos_Application_MCQ_3 from "../JavaScript/Todos_Application_2/Todos_Application_MCQ_3";
import Todos_Application_MCQ_4 from "../JavaScript/Todos_Application_2/Todos_Application_MCQ_4";
import Todos_Application_MCQ_5 from "../JavaScript/Todos_Application_3/Todos_Application_MCQ_5";
import Todos_Application_MCQ_6 from "../JavaScript/Todos_Application_4/Todos_Application_MCQ_6";
import Callbacks_Schedulers_MCQ from "../JavaScript/Fetch_Callbacks/Callbacks_Schedulers_MCQ";
import Event_Listners_More_Events_MCQ from "../JavaScript/Fetch_Callbacks/Event_Listners_More_Events_MCQ";
import Hypertext_Transer_Protocal_MCQ from "../JavaScript/Fetch_Callbacks/Hypertext_Transer_Protocal_MCQ";
import HTTP_Request_Using_JS_MCQ from "../JavaScript/Fetch_Callbacks_2/HTTP_Request_Using_JS_MCQ";
import Wikipedia_Search_MCQ from "../JavaScript/Fetch_Callbacks_2/Wikipedia_Search_MCQ";
import Forms_MCQ_1 from "../JavaScript/Forms/Forms_MCQ_1";
import Forms_MCQ_2 from "../JavaScript/Forms/Forms_MCQ_2";
import JS_MCQ_Assignment_1 from "../JavaScript/Assignment/JS_MCQ_Assignment_1";
import JS_MCQ_Assignment_2 from "../JavaScript/Assignment/JS_MCQ_Assignment_2";
import JS_MCQ_Assignment_3 from "../JavaScript/Assignment/JS_MCQ_Assignment_3";
import JS_MCQ_Assignment_4 from "../JavaScript/Assignment/JS_MCQ_Assignment_4";
import JS_MCQ_Test_1 from "../JavaScript/Mock_Test/JS_MCQ_Test_1.js";
import JS_MCQ_Test_2 from "../JavaScript/Mock_Test/JS_MCQ_Test_2.js";

//JavaScript Essentials

import More_Modern_JS_Concepts_CS from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_CS.js";
import More_Modern_Js_Concepts_MCQ from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_MCQ.js";
import More_Modern_JS_Concepts_CS_2 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_CS_2.js";
import More_Modern_JS_Concepts_MCQ_2 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_MCQ_2.js";
import Factory_Constructor_Function_CS from "../JavaScript_Essentials/More_Modern_JS_Concepts/Factory_Constructor_Function_CS.js";
import Factory_Constructor_Function_MCQ from "../JavaScript_Essentials/More_Modern_JS_Concepts/Factory_Constructor_Function_MCQ.js";
import More_Modern_JS_Concepts_CS_3 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_CS_3.js";
import More_Modern_JS_Concepts_MCQ_3 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_MCQ_3.js";
import Prototypal_Inheritance_CS from "../JavaScript_Essentials/Prototypes_Classes/Prototypal_Inheritance_CS.js";
import Prototypal_Inheritance_MCQ from "../JavaScript_Essentials/Prototypes_Classes/Prototypal_Inheritance_MCQ.js";
import JS_Classes_CS from "../JavaScript_Essentials/Prototypes_Classes/JS_Classes_CS.js";
import JS_Classes_MCQ from "../JavaScript_Essentials/Prototypes_Classes/JS_Classes_MCQ.js";
import JS_Promises_MCQ from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises_MCQ.js";
import JS_Promises_CS from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises_CS.js";
import JS_Promises_CS_2 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises_CS_2.js";
import JS_Promises_MCQ_2 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises_MCQ_2.js";
import More_JS_Conceptes_CS from "../JavaScript_Essentials/Promises_Array_Methods/More_JS_Conceptes_CS.js";
import More_JS_Concepte_MCQ from "../JavaScript_Essentials/Promises_Array_Methods/More_JS_Concepte_MCQ.js";
import JS_Essential_MCQ_Assignment_1 from "../JavaScript_Essentials/Assignments/JS_Essential_MCQ_Assignment_1.js";
import JS_Essential_MCQ_Assignment_2 from "../JavaScript_Essentials/Assignments/JS_Essential_MCQ_Assignment_2.js";
import JS_Essential_MCQ_Assignment_3 from "../JavaScript_Essentials/Assignments/JS_Essential_MCQ_Assignment_3.js";
import JS_Essential_MCQ_Assignment_4 from "../JavaScript_Essentials/Assignments/JS_Essential_MCQ_Assignment_4.js";
import JS_Essential_Mock_Tests_MCQ_1 from "../JavaScript_Essentials/Mock_Tests/JS_Essential_Mock_Tests_MCQ_1.js";
import JS_Essential_Mock_Tests_MCQ_2 from "../JavaScript_Essentials/Mock_Tests/JS_Essential_Mock_Tests_MCQ_2.js";

//SQL Coding Pratice
import SQL_Coding_Pratice_1 from "../SQL_Database/Introdutionto_SQL/SQL_Coding_Pratice_1.js";
import SQL_Coding_Pratice_2 from "../SQL_Database/Introdutionto_SQL/SQL_Coding_Pratice_2.js";
import SQL_Coding_Pratice_3 from "../SQL_Database/Quering_SQL/SQL_Coding_Pratice_3.js";
import SQL_Coding_Pratice_4 from "../SQL_Database/Quering_SQL/SQL_Coding_Pratice_4.js";
import SQL_Coding_Pratice_5 from "../SQL_Database/Quering_SQL/SQL_Coding_Pratice_5.js";
import SQL_Coding_Pratice_6 from "../SQL_Database/Aggregations/SQL_Coding_Pratice_6.js";
import SQL_Coding_Pratice_7 from "../SQL_Database/Common_Concepts/SQL_Coding_Pratice_7.js";
import SQL_Coding_Pratice_8 from "../SQL_Database/Modelling_Databases/SQL_Coding_Pratice_8.js";

//Nodejs cheat sheets
import Introductionto_Nodejs_CS from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs_CS.js";
import Introductionto_Nodejs_MCQ from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs_MCQ.js";
import Commojs_Module_Readig_Material_CS from "../Nodejs/Intoductionto_Nodejs/Commojs_Module_Readig_Material_CS.js";
import Commojs_Module_Readig_Material_MCQ from "../Nodejs/Intoductionto_Nodejs/Commojs_Module_Readig_Material_MCQ.js";
import ES6_Module_CS from "../Nodejs/Intoductionto_Nodejs/ES6_Module_CS.js";
import ES6_Module_MCQ from "../Nodejs/Intoductionto_Nodejs/ES6_Module_MCQ.js";
import Introductionto_Nodejs_CS_2 from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs_CS_2.js";
import Introductionto_Nodejs_MCQ_2 from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs_MCQ_2.js";
import Introductionto_Expressjs_CS_1 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_CS_1.js";
import Introductionto_Expressjs_MCQ_1 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_MCQ_1.js";
import Introductionto_Expressjs_CS_2 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_CS_2.js";
import Introductionto_Expressjs_MCQ_2 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_MCQ_2.js";
import Introductionto_Expressjs_CS_3 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_CS_3.js";
import Introductionto_Expressjs_MCQ_3 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_MCQ_3.js";
import Rest_API_CS from "../Nodejs/REST_APIs/Rest_API_CS.js";
import Rest_API_MCQ from "../Nodejs/REST_APIs/Rest_API_MCQ.js";
import Debug_Cmmn_Errors_CS from "../Nodejs/REST_APIs/Debug_Cmmn_Errors_CS.js";
import Debug_Cmmn_Errors_P2_CS from "../Nodejs/REST_APIs/Debug_Cmmn_Errors_P2_CS.js";
import Debug_Cmmn_Errors_MCQ from "../Nodejs/REST_APIs/Debug_Cmmn_Errors_MCQ.js";
import Athantication_CS_1 from "../Nodejs/Athantication/Athantication_CS_1.js";
import Athantication_MCQ_1 from "../Nodejs/Athantication/Athantication_MCQ_1.js";
import Athantication_CS_2 from "../Nodejs/Athantication/Athantication_CS_2.js";
import Athantication_MCQ_2 from "../Nodejs/Athantication/Athantication_MCQ_2.js";
import Athantication_CS_3 from "../Nodejs/Athantication/Athantication_CS_3.js";
import Athantication_MCQ_3 from "../Nodejs/Athantication/Athantication_MCQ_3.js";

//Git
import Understaing_Binary_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Understaing_Binary_CS.js";
import Understaing_Binary_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Understaing_Binary_MCQ.js";
import Computer_Hardware_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Computer_Hardware_CS.js";
import  Computer_Hardware_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Computer_Hardware_MCQ.js";
import Introductionto_Operating_System_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Introductionto_Operating_System_CS.js";
import Introductionto_Operating_System_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Introductionto_Operating_System_MCQ.js";
import Process_Managent_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Process_Managent_CS.js";
import Process_Managent_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Process_Managent_MCQ.js";
import Threads_Courrency_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Threads_Courrency_CS.js";
import  Threads_Courrency_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Threads_Courrency_MCQ.js";
import Memory_Managent_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Memory_Managent_CS.js";
import Memory_Managent_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Memory_Managent_MCQ.js";
import Compter_Networks from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Compter_Networks.js";
import Compter_Networks_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Compter_Networks_CS.js";
import  Compter_Networks_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Compter_Networks_MCQ.js";
import Network_Layer_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Network_Layer_CS.js";
import Network_Layer_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Network_Layer_MCQ.js";
import Transport_Layers_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Transport_Layers_CS.js";
import Transport_Layers_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Transport_Layers_MCQ.js";
import Application_Layer_CS from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Application_Layer_CS.js";
import Application_Layer_MCQ from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Application_Layer_MCQ.js";
import Working_Command_Line_CS from "../Developer_Foundations/Working_Command_Line/Working_Command_Line_CS.js";
import Working_Command_Line_MCQ from "../Developer_Foundations/Working_Command_Line/Working_Command_Line_MCQ.js";
import Settingup_WSL2_CS from "../Developer_Foundations/Working_Command_Line/Settingup_WSL2_CS.js";
import Working_File_System_CS from "../Developer_Foundations/Working_Command_Line/Working_File_System_CS.js";
import Working_with_Files_CS from "../Developer_Foundations/Working_Command_Line/Working_with_Files_CS.js";
import Working_with_Files_MCQ from "../Developer_Foundations/Working_Command_Line/Working_with_Files_MCQ.js";
import Working_File_System_MCQ from "../Developer_Foundations/Working_Command_Line/Working_File_System_MCQ.js";
import Miscellaneous_Commands_CS_1 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_CS_1.js";
import Miscellaneous_Commands_MCQ_1 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_MCQ_1.js";
import Miscellaneous_Commands_CS_2 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_CS_2.js";
import Miscellaneous_Commands_MCQ_2 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_MCQ_2.js";
import Getting_Started_Git_CS from "../Developer_Foundations/Collabarating_with_Git/Getting_Started_Git_CS.js";
import  Getting_Started_Git_MCQ from "../Developer_Foundations/Collabarating_with_Git/Getting_Started_Git_MCQ.js";
import Staging_Area_Commits_CS from "../Developer_Foundations/Collabarating_with_Git/Staging_Area_Commits_CS.js";
import Staging_Area_Commits_MCQ from "../Developer_Foundations/Collabarating_with_Git/Getting_Started_Git_MCQ.js";


//Python OOPS CORE
import FoundationsOfOOP_CheatSheet from "../Python/IntroductiontoOOP/FoundationsOfOOP_CheatSheet.js";
import FoundationsOfOOP_CheatSheet_2 from "../Python/IntroductiontoOOP/FoundationsOfOOP_CheatSheet_2.js";
import FoundationsOfOOP_Coding_Pratice from "../Python/IntroductiontoOOP/FoundationsOfOOP_Coding_Pratice.js";
import Miscellaneous_Python_Library_CheeatSheet from "../Python/Miscellaneous/Miscellaneous_Python_Library_CheeatSheet.js";
import Miscellaneous_Python_Library_MCQ from "../Python/Miscellaneous/Miscellaneous_Python_Library_MCQ.js";
import Miscellaneous_Python_Library_Coding_Pratice from "../Python/Miscellaneous/Miscellaneous_Python_Library_Coding_Pratice.js";

//Nodejs
import Mern_Stack from "../Nodejs/Mern_Stack/Mern_Stack.js";
import Introductionto_Nodejs from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs.js";
import Introductionto_Nodejs_2 from "../Nodejs/Intoductionto_Nodejs/Introductionto_Nodejs_2.js";
import Nodejs_Coding_Pratice_1 from "../Nodejs/Intoductionto_Nodejs/Nodejs_Coding_Pratice_1.js";
import Nodejs_Coding_Pratice_2 from "../Nodejs/Intoductionto_Nodejs/Nodejs_Coding_Pratice_2.js";
import Node_Hyper_Text_Transfer_Protocal from "../Nodejs/Introductionto_Expressjs/Node_Hyper_Text_Transfer_Protocal.js";
import Introductionto_Expressjs from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs.js";
import Introductionto_Expressjs_2 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_2.js";
import Introductionto_Expressjs_3 from "../Nodejs/Introductionto_Expressjs/Introductionto_Expressjs_3.js";
import Debug_Cmmn_Errors from "../Nodejs/REST_APIs/Debug_Cmmn_Errors.js";
import Debug_Cmmn_Errors_P2 from "../Nodejs/REST_APIs/Debug_Cmmn_Errors_P2.js";
import Rest_APIs from "../Nodejs/REST_APIs/Rest_APIs.js";
import Nodejs_Coding_Pratice_3 from "../Nodejs/Introductionto_Expressjs/Nodejs_Coding_Pratice_3.js";
import Nodejs_Coding_Pratice_4 from "../Nodejs/Introductionto_Expressjs/Nodejs_Coding_Pratice_4.js";
import Nodejs_Coding_Pratice_5 from "../Nodejs/Introductionto_Expressjs/Nodejs_Coding_Pratice_5.js";
import Nodejs_Coding_Pratice_6 from "../Nodejs/Introductionto_Expressjs/Nodejs_Coding_Pratice_6.js";
import Nodejs_Coding_Pratice_7 from "../Nodejs/Introductionto_Expressjs/Nodejs_Coding_Pratice_7.js";
import Nodejs_Coding_Pratice_8 from "../Nodejs/REST_APIs/Nodejs_Coding_Pratice_8.js";
import Nodejs_Coding_Pratice_9 from "../Nodejs/Athantication/Nodejs_Coding_Pratice_9.js";
import Nodejs_Coding_Pratice_10 from "../Nodejs/Athantication/Nodejs_Coding_Pratice_10.js";
import Athantication_1 from "../Nodejs/Athantication/Athantication_1.js";
import Athantication_2 from "../Nodejs/Athantication/Athantication_2.js";
import Athantication_3 from "../Nodejs/Athantication/Athantication_3.js";
import Nodejs_Coding_Assignmet_1 from "../Nodejs/Assignments/Nodejs_Coding_Assignmet_1.js";
import Nodejs_Coding_Assignmet_2 from "../Nodejs/Assignments/Nodejs_Coding_Assignmet_2.js";
import Nodejs_Mock_Test_1 from "../Nodejs/Mock_Tests/Nodejs_Mock_Test_1.js";
import Nodejs_Mock_Test_2 from "../Nodejs/Mock_Tests/Nodejs_Mock_Test_2.js";
import Nodejs_Mock_Test_3 from "../Nodejs/Mock_Tests/Nodejs_Mock_Test_3.js";
import Nodejs_Course_exam_Instructions from "../Nodejs/Nodejs_Course_Exam/Nodejs_Course_exam_Instructions.js";
import Nodejs_Course_Exam from "../Nodejs/Nodejs_Course_Exam/Nodejs_Course_Exam.js";
//Reactjs class & codingPratices
import Introductionto_Reactjs from "../Reactjs/Introductionto_Reactjs/Introductionto_Reactjs.js";
import Components_Props from "../Reactjs/Introductionto_Reactjs/Components_Props.js";
import List_Keys from "../Reactjs/Introductionto_Reactjs/List_Keys.js";
import React_Coding_Practice_1 from "../Reactjs/Introductionto_Reactjs/React_Coding_Practice_1.js";
import React_Coding_Practice_2 from "../Reactjs/Introductionto_Reactjs/React_Coding_Practice_2.js";
import React_Coding_Practice_3 from "../Reactjs/Introductionto_Reactjs/React_Coding_Practice_3.js";
import Class_Component_State1 from "../Reactjs/Class_Component_State1/Class_Component_State1.js";
import Noteon_React_Versions from "../Reactjs/Class_Component_State1/Noteon_React_Versions.js";
import Conditional_Render from "../Reactjs/Class_Component_State1/Conditional_Render.js";
import Debugging_Dev_Tools from "../Reactjs/Debugging/Debugging_Dev_Tools.js";
import React_Coding_Practice_4 from "../Reactjs/Class_Component_State1/React_Coding_Practice_4.js";
import React_Coding_Practice_5 from "../Reactjs/Class_Component_State1/React_Coding_Practice_5.js";
import Class_Component_State2 from "../Reactjs/Class_Component_State2/Class_Component_State2.js";
import React_Coding_Practice_6 from "../Reactjs/Class_Component_State2/React_Coding_Practice_6.js";
import React_Coding_Practice_7 from "../Reactjs/Class_Component_State2/React_Coding_Practice_7.js";
import React_Coding_Practice_8 from "../Reactjs/Class_Component_State2/React_Coding_Practice_8.js";
import React_Assignment_1 from "../Reactjs/Class_Component_State2/React_Assignment_1.js";
import Common_Mistakes from "../Reactjs/Common_Mistakes/Common_Mistakes.js";
import Ondemand_Sessions_Part1 from "../Reactjs/Working_With_Lists/Ondemand_Sessions_Part1.js";
import Ondemand_sessions_part2 from "../Reactjs/Working_With_Lists/Ondemand_sessions_part2.js";
import Component_Life_Cycle from "../Reactjs/Component_Life_Cycle/Component_Life_Cycle.js";
import React_Router1 from "../Reactjs/React_Router/React_Router1.js";
import React_Router2 from "../Reactjs/React_Router/React_Router2.js";
import Common_M_Part_2 from "../Reactjs/React_Router/Common_M_Part_2.js";
import Authentication from "../Reactjs/Authentication/Authentication.js";
import Authentication_2 from "../Reactjs/Authentication/Authentication_2.js";
import Authentication_3 from "../Reactjs/Authentication/Authentication_3.js";
import Authentication_P4 from "../Reactjs/Authentication2/Authentication_P4.js";
import SortingProducts from "../Reactjs/Authentication2/SortingProducts.js";
import More_React from "../Reactjs/More_React_Concepts/More_React.js";
import Third_Party from "../Reactjs/Third_Party/Third_Party.js";
import React_Context_1 from "../Reactjs/React_Context/React_Context_1.js";
import React_Context_2 from "../Reactjs/React_Context/React_Context_2.js";
import React_Context_3 from "../Reactjs/React_Context/React_Context_3.js";
import React_Context_4 from "../Reactjs/React_Context/React_Context_4.js";
import Styled_Components from "../Reactjs/Styled_Components/Styled_Components.js";
import React_Assignment_2 from "../Reactjs/Component_Life_Cycle/React_Assignment_2.js";
import React_Assignment_3 from "../Reactjs/Component_Life_Cycle/React_Assignment_3.js";
import React_Assignment_4 from "../Reactjs/React_Router/React_Assignment_4.js";
import React_Assignment_5 from "../Reactjs/Jobby_App/React_Assignment_5.js";
import React_Assignment_6 from "../Reactjs/Assignments/React_Assignment_6.js";
import React_Assignment_7 from "../Reactjs/Assignments/React_Assignment_7.js";
import React_Coding_Practice_9 from "../Reactjs/Common_Mistakes/React_Coding_Practice_9.js";
import React_Coding_Practice_10 from "../Reactjs/Common_Mistakes/React_Coding_Practice_10.js";
import React_Coding_Practice_11 from "../Reactjs/Debugging/React_Coding_Practice_11.js";
import React_Coding_Practice_12 from "../Reactjs/Working_With_Lists/React_Coding_Practice_12.js";
import React_Coding_Practice_13 from "../Reactjs/Working_With_Lists/React_Coding_Practice_13.js";
import React_Coding_Practice_14 from "../Reactjs/Working_With_Lists/React_Coding_Practice_14.js";
import React_Coding_Practice_15 from "../Reactjs/Working_With_Lists/React_Coding_Practice_15.js";
import React_Coding_Practice_16 from "../Reactjs/Working_With_Lists/React_Coding_Practice_16.js";
import React_Coding_Practice_17 from "../Reactjs/Working_With_Lists/React_Coding_Practice_17.js";
import React_Coding_Practice_18 from "../Reactjs/Working_With_Lists/React_Coding_Practice_18.js";
import React_Coding_Practice_19 from "../Reactjs/Component_Life_Cycle/React_Coding_Practice_19.js";
import React_Coding_Practice_20 from "../Reactjs/Component_Life_Cycle/React_Coding_Practice_20.js";
import React_Coding_Practice_21 from "../Reactjs/Component_Life_Cycle/React_Coding_Practice_21.js";
import React_Coding_Practice_22 from "../Reactjs/React_Router/React_Coding_Practice_22.js";
import React_Coding_Practice_23 from "../Reactjs/React_Router/React_Coding_Practice_23.js";
import React_Coding_Practice_24 from "../Reactjs/React_Router/React_Coding_Practice_24.js";
import React_Coding_Practice_25 from "../Reactjs/React_Router/React_Coding_Practice_25.js";
import React_Coding_Practice_26 from "../Reactjs/React_Router/React_Coding_Practice_26.js";
import React_Coding_Practice_27 from "../Reactjs/Authentication/React_Coding_Practice_27.js";
import React_Coding_Practice_28 from "../Reactjs/Authentication/React_Coding_Practice_28.js";
import React_Coding_Practice_29 from "../Reactjs/Authentication/React_Coding_Practice_29.js";
import React_Coding_Practice_30 from "../Reactjs/Authentication/React_Coding_Practice_30.js";
import React_Coding_Practice_31 from "../Reactjs/Authentication/React_Coding_Practice_31.js";
import React_Coding_Practice_32 from "../Reactjs/Authentication2/React_Coding_Practice_32.js";
import React_Coding_Practice_33 from "../Reactjs/Authentication2/React_Coding_Practice_33.js";
import React_Coding_Practice_34 from "../Reactjs/Authentication2/React_Coding_Practice_34.js";
import React_Coding_Practice_35 from "../Reactjs/Authentication2/React_Coding_Practice_35.js";
import React_Coding_Practice_36 from "../Reactjs/More_React_Concepts/React_Coding_Practice_36.js";
import React_Coding_Practice_37 from "../Reactjs/Third_Party/React_Coding_Practice_37.js";
import React_Coding_Practice_38 from "../Reactjs/Third_Party/React_Coding_Practice_38.js";
import React_Coding_Practice_39 from "../Reactjs/Third_Party/React_Coding_Practice_39.js";
import React_Coding_Practice_40 from "../Reactjs/Third_Party/React_Coding_Practice_40.js";
import React_Coding_Practice_41 from "../Reactjs/React_Context/React_Coding_Practice_41.js";
import React_Coding_Practice_42 from "../Reactjs/React_Context/React_Coding_Practice_42.js";
import React_Coding_Practice_43 from "../Reactjs/React_Context/React_Coding_Practice_43.js";
import React_Coding_Practice_44 from "../Reactjs/Styled_Components/React_Coding_Practice_44.js";
import React_Coding_Practice_45 from "../Reactjs/Styled_Components/React_Coding_Practice_45.js";
import Interview_Mock_Test_1A from "../Reactjs/Mock_Tests/Interview_Mock_Test_1A.js";
import Interview_Mock_Test_1B from "../Reactjs/Mock_Tests/Interview_Mock_Test_1B.js";
import Interview_Mock_Test_1C from "../Reactjs/Mock_Tests/Interview_Mock_Test_1C.js";
import Interview_Mock_Test_1D from "../Reactjs/Mock_Tests/Interview_Mock_Test_1D.js";
import Interview_Mock_Test_1E from "../Reactjs/Mock_Tests/Interview_Mock_Test_1E.js";

//Git
import Understaing_Binary from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Understaing_Binary.js";
import OverViewof_Hardware from "../Developer_Foundations/Foundamentals_Of_Computer_Science/OverViewof_Hardware.js";
import Application_Layer from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Application_Layer.js";
import Introductionto_Operating_System from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Introductionto_Operating_System.js";
import Process_Managent from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Process_Managent.js";
import Memory_Managent from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Memory_Managent.js";
import Threads_Courrency from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Threads_Courrency.js";
import Network_Layer from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Network_Layer.js";
import Transport_Layers from "../Developer_Foundations/Foundamentals_Of_Computer_Science/Transport_Layers.js";
import Working_File_System from "../Developer_Foundations/Working_Command_Line/Working_File_System.js";
import Working_Command_Line from "../Developer_Foundations/Working_Command_Line/Working_Command_Line.js";
import Working_with_Files from "../Developer_Foundations/Working_Command_Line/Working_with_Files.js";
import Miscellaneous_Commands_1 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_1.js";
import Miscellaneous_Commands_2 from "../Developer_Foundations/Working_Command_Line/Miscellaneous_Commands_2.js";
import Google_Cloud_Sheel from "../Developer_Foundations/Working_Command_Line/Google_Cloud_Sheel.js";
import Getting_Started_Git from "../Developer_Foundations/Collabarating_with_Git/Getting_Started_Git.js";
import Staging_Area_Commits from "../Developer_Foundations/Collabarating_with_Git/Staging_Area_Commits.js";
import SettingUp_WSL2 from "../Developer_Foundations/Working_Command_Line/SettingUp_WSL2.js";
import Developer_Foundations_Course_Exam_Instructions from "../Developer_Foundations/Developer_Foundations_Course_Exam/Developer_Foundations_Course_Exam_Instructions.js";
import Developer_Foundations_Course_Exam from "../Developer_Foundations/Developer_Foundations_Course_Exam/Developer_Foundations_Course_Exam.js";

//Frontend Interview set
import Bootstrap_Practice_set from "../Frontend_Interview_Kit/Bootstrap_Practice_set.js";
import HTML_Practice_Set_1 from "../Frontend_Interview_Kit/HTML_Practice_Set_1.js";
import HTML_Practice_Set_2 from "../Frontend_Interview_Kit/HTML_Practice_Set_2.js";
import HTML_Practice_Set_3 from "../Frontend_Interview_Kit/HTML_Practice_Set_3.js";
import HTML_Practice_Set_4 from "../Frontend_Interview_Kit/HTML_Practice_Set_4.js";
import CSS_Practice_Set_1 from "../Frontend_Interview_Kit/CSS_Practice_Set_1.js";
import CSS_Practice_Set_2 from "../Frontend_Interview_Kit/CSS_Practice_Set_2.js";
import CSS_Practice_Set_3 from "../Frontend_Interview_Kit/CSS_Practice_Set_3.js";
import CSS_Practice_Set_4 from "../Frontend_Interview_Kit/CSS_Practice_Set_4.js";
import CSS_Practice_Set_5 from "../Frontend_Interview_Kit/CSS_Practice_Set_5.js";
import Python_Practice_Set_1 from "../Frontend_Interview_Kit/Python_Practice_Set_1.js";
import Python_Practice_Set_2 from "../Frontend_Interview_Kit/Python_Practice_Set_2.js";
import Python_Practice_Set_3 from "../Frontend_Interview_Kit/Python_Practice_Set_3.js";
import Python_Practice_Set_4 from "../Frontend_Interview_Kit/Python_Practice_Set_4.js";
import SQL_Practice_Set_1 from "../Frontend_Interview_Kit/SQL_Practice_Set_1.js";
import SQL_Practice_Set_2 from "../Frontend_Interview_Kit/SQL_Practice_Set_2.js";
import SQL_Practice_Set_3 from "../Frontend_Interview_Kit/SQL_Practice_Set_3.js";
import SQL_Practice_Set_4 from "../Frontend_Interview_Kit/SQL_Practice_Set_4.js";

//Backend Interview set
import JavaScript_Practice_Set_1 from "../Backend_Interview_Kit/JavaScript_Practice_Set_1.js";
import JavaScript_Practice_Set_2 from "../Backend_Interview_Kit/JavaScript_Practice_Set_2.js";
import JavaScript_Practice_Set_3 from "../Backend_Interview_Kit/JavaScript_Practice_Set_3.js";
import JavaScript_Practice_Set_4 from "../Backend_Interview_Kit/JavaScript_Practice_Set_4.js";
import NodeJS_Practice_Set_1 from "../Backend_Interview_Kit/NodeJS_Practice_Set_1.js";
import NodeJS_Practice_Set_2 from "../Backend_Interview_Kit/NodeJS_Practice_Set_2.js";
import NodeJS_Practice_Set_3 from "../Backend_Interview_Kit/NodeJS_Practice_Set_3.js";
import NodeJS_Practice_Set_4 from "../Backend_Interview_Kit/NodeJS_Practice_Set_4.js";
import ReactJs_Practice_Set_1 from "../Backend_Interview_Kit/ReactJs_Practice_Set_1.js";
import ReactJs_Practice_Set_2 from "../Backend_Interview_Kit/ReactJs_Practice_Set_2.js";
import ReactJs_Practice_Set_3 from "../Backend_Interview_Kit/ReactJs_Practice_Set_3.js";
import ReactJs_Practice_Set_4 from "../Backend_Interview_Kit/ReactJs_Practice_Set_4.js";

//Js Essentials
import More_Modern_JS_Concepts from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts.js";
import More_Modern_JS_Concepts_2 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_2.js";
import More_Modern_JS_Concepts_3 from "../JavaScript_Essentials/More_Modern_JS_Concepts/More_Modern_JS_Concepts_3.js";
import Factory_Constructor_Function from "../JavaScript_Essentials/More_Modern_JS_Concepts/Factory_Constructor_Function.js";
import JS_Promises from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises.js";
import JS_Promises_2 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Promises_2.js";
import More_JS_Concepte from "../JavaScript_Essentials/Promises_Array_Methods/More_JS_Concepte.js";
import Clean_Code_Guidence from "../JavaScript_Essentials/Promises_Array_Methods/Clean_Code_Guidence.js";
import JS_Classes from "../JavaScript_Essentials/Prototypes_Classes/JS_Classes.js";
import Prototypal_Inheritance from "../JavaScript_Essentials/Prototypes_Classes/Prototypal_Inheritance.js";
import JS_Essentials_Coding_Pratice_1 from "../JavaScript_Essentials/More_Modern_JS_Concepts/JS_Essentials_Coding_Pratice_1.js";
import JS_Essentials_Coding_Pratice_2 from "../JavaScript_Essentials/More_Modern_JS_Concepts/JS_Essentials_Coding_Pratice_2.js";
import JS_Essentials_Coding_Pratice_3 from "../JavaScript_Essentials/More_Modern_JS_Concepts/JS_Essentials_Coding_Pratice_3.js";
import JS_Essentials_Coding_Pratice_4 from "../JavaScript_Essentials/More_Modern_JS_Concepts/JS_Essentials_Coding_Pratice_4.js";
import JS_Essentials_Coding_Pratice_5 from "../JavaScript_Essentials/Prototypes_Classes/JS_Essentials_Coding_Pratice_5.js";
import JS_Essentials_Coding_Pratice_6 from "../JavaScript_Essentials/Prototypes_Classes/JS_Essentials_Coding_Pratice_6.js";
import JS_Essentials_Coding_Pratice_7 from "../JavaScript_Essentials/Prototypes_Classes/JS_Essentials_Coding_Pratice_7.js";
import JS_Essentials_Coding_Pratice_8 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Essentials_Coding_Pratice_8.js";
import JS_Essentials_Coding_Pratice_9 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Essentials_Coding_Pratice_9.js";
import JS_Essentials_Coding_Pratice_10 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Essentials_Coding_Pratice_10.js";
import JS_Essentials_Coding_Pratice_11 from "../JavaScript_Essentials/Promises_Array_Methods/JS_Essentials_Coding_Pratice_11.js";
import JS_Essentials_Assignment_1 from "../JavaScript_Essentials/Assignments/JS_Essentials_Assignment_1.js";
import JS_Essentials_Assignment_2 from "../JavaScript_Essentials/Assignments/JS_Essentials_Assignment_2.js";
import JS_Essentials_Assignment_3 from "../JavaScript_Essentials/Assignments/JS_Essentials_Assignment_3.js";
import JS_Essentials_Assignment_4 from "../JavaScript_Essentials/Assignments/JS_Essentials_Assignment_4.js";
import JS_Essential_Mock_Coding_Test_1 from "../JavaScript_Essentials/Mock_Tests/JS_Essential_Mock_Coding_Test_1.js";
import JS_Essential_Mock_Coding_Test_2 from "../JavaScript_Essentials/Mock_Tests/JS_Essential_Mock_Coding_Test_2.js";
import JavaScript_Essentials_Course_Exam_Instruction from "../JavaScript_Essentials/JavaScript_Essentials_Course_Exam/JavaScript_Essentials_Course_Exam_Instruction.js";
import JavaScript_Essentials_Course_Exam from "../JavaScript_Essentials/JavaScript_Essentials_Course_Exam/JavaScript_Essentials_Course_Exam.js";
import Introductionto_CSS_Flexbox from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox.js";
import Introductionto_CSS_Flexbox_2 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_2.js";
import Introductionto_CSS_Flexbox_3 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_3.js";
import Sizing_Ele_Handling_Overflow from "../FlexBox/CSS_Flexbox/Sizing_Ele_Handling_Overflow.js";
import CSS_Media_Queries from "../FlexBox/CSS_Media_Queries/CSS_Media_Queries.js";
import Box_Sizing from "../FlexBox/CSS_Flexbox/Box_Sizing.js";
import CSS_Media_Queries_CS from "../FlexBox/CSS_Media_Queries/CSS_Media_Queries_CS.js";
import CSS_Media_Queries_MCQ from "../FlexBox/CSS_Media_Queries/CSS_Media_Queries_MCQ.js";
import Flexbox_Sizing from "../FlexBox/CSS_Media_Queries/Flexbox_Sizing.js";
import Flexbox_Sizing_CS from "../FlexBox/CSS_Media_Queries/Flexbox_Sizing_CS.js";
import Flexbox_Sizing_MCQ from "../FlexBox/CSS_Media_Queries/Flexbox_Sizing_MCQ.js";
import Media_Queries_On_Demand_Session from "../FlexBox/CSS_Media_Queries/Media_Queries_On_Demand_Session.js";
import Flexbox_On_Demand_Session_CS from "../FlexBox/CSS_Media_Queries/Flexbox_On_Demand_Session_CS.js";
import Flexbox_On_Demand_Session_MCQ from "../FlexBox/CSS_Media_Queries/Flexbox_On_Demand_Session_MCQ.js";
import Flexbox_Coding_Pratice_1 from "../FlexBox/CSS_Flexbox/Flexbox_Coding_Pratice_1.js";
import Flexbox_Coding_Pratice_2 from "../FlexBox/CSS_Flexbox/Flexbox_Coding_Pratice_2.js";
import Flexbox_Coding_Pratice_3 from "../FlexBox/CSS_Flexbox/Flexbox_Coding_Pratice_3.js";
import Flexbox_Coding_Pratice_4 from "../FlexBox/CSS_Flexbox/Flexbox_Coding_Pratice_4.js";
import Flexbox_Coding_Pratice_5 from "../FlexBox/CSS_Media_Queries/Flexbox_Coding_Pratice_5.js";
import Flexbox_Coding_Pratice_6 from "../FlexBox/CSS_Media_Queries/Flexbox_Coding_Pratice_6.js";
import Flexbox_Coding_Pratice_7 from "../FlexBox/CSS_Media_Queries/Flexbox_Coding_Pratice_7.js";
import Flexbox_Coding_Pratice_8 from "../FlexBox/CSS_Media_Queries/Flexbox_Coding_Pratice_8.js";
import Flexbox_Coding_Assignment_1 from "../FlexBox/Assignments/Flexbox_Coding_Assignment_1.js";
import Flexbox_Coding_Assignment_2 from "../FlexBox/Assignments/Flexbox_Coding_Assignment_2.js";
import Flexbox_Coding_Assignment_3 from "../FlexBox/Assignments/Flexbox_Coding_Assignment_3.js";
import Flexbox_Coding_Assignment_4 from "../FlexBox/Assignments/Flexbox_Coding_Assignment_4.js";
import Flexbox_MCQ_Assignment_1 from "../FlexBox/Assignments/Flexbox_MCQ_Assignment_1.js";
import Flexbox_MCQ_Assignment_2 from "../FlexBox/Assignments/Flexbox_MCQ_Assignment_2.js";
import Flexbox_MCQ_Assignment_3 from "../FlexBox/Assignments/Flexbox_MCQ_Assignment_3.js";
import Flexbox_MCQ_Assignment_4 from "../FlexBox/Assignments/Flexbox_MCQ_Assignment_4.js";
import Box_Sizing_MCQ from "../FlexBox/CSS_Flexbox/Box_Sizing_MCQ.js";
import Introductionto_CSS_Flexbox_MCQ_3 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_MCQ_3.js";
import Introductionto_CSS_Flexbox_MCQ_2 from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_MCQ_2.js";
import Introductionto_CSS_Flexbox_MCQ from "../FlexBox/CSS_Flexbox/Introductionto_CSS_Flexbox_MCQ.js";
import Sizing_Ele_Handling_Overflow_MCQ from "../FlexBox/CSS_Flexbox/Sizing_Ele_Handling_Overflow_MCQ.js";
import Flexbox_MockTest_1 from "../FlexBox/Mock_Tests/Flexbox_MockTest_1.js";
import Flexbox_MockTest_2 from "../FlexBox/Mock_Tests/Flexbox_MockTest_2.js";
import InputEle_MathFunctions_MCQ from "../JavaScript/Introductionto_Js_Variables/InputEle_MathFunctions_MCQ.js";
import Flexbox_Course_Exam_Instructions from "../FlexBox/Flexbox_Course_Exam/Flexbox_Course_Exam_Instructions.js";
import Flexbox_Corse_Exam from "../FlexBox/Flexbox_Course_Exam/Flexbox_Corse_Exam.js";

import React_Router3 from "../Reactjs/React_Router/React_Router3.js";
import React_Course_Exam_Instructions from "../Reactjs/React_Course_Exam/React_Course_Exam_Instructions.js";
import React_Course_Exam from "../Reactjs/React_Course_Exam/React_Course_Exam.js";
export const subtopicComponents = {
  "MCQ Pratice - Box Sizing": Box_Sizing_MCQ,
  "MCQ Pratice - CSS Flexbox 3": Introductionto_CSS_Flexbox_MCQ_3,
  "MCQ Pratice - CSS Flexbox 2": Introductionto_CSS_Flexbox_MCQ_2,
   "MCQ Pratice - CSS Flexbox 1": Introductionto_CSS_Flexbox_MCQ,
  "MCQ Pratice - Sizing Elements and Handling Overflow":Sizing_Ele_Handling_Overflow_MCQ,
  "MCQ Pratice - CSS Media Queries": CSS_Media_Queries_MCQ,
  "CSS Media Queries": CSS_Media_Queries,
  "CSS Media Queries | Cheat Sheet": CSS_Media_Queries_CS,
  "Flexbox Sizing": Flexbox_Sizing,
  "Box Sizing": Box_Sizing,
  "Flexbox Sizing | Cheat Sheet":Flexbox_Sizing_CS,
  "MCQ Pratice - Flexbox Sizing": Flexbox_Sizing_MCQ,
  "Media Queries OnDemand Session":Media_Queries_On_Demand_Session,
  "Media Queries OnDemand Session | Cheat Sheet": Flexbox_On_Demand_Session_CS,
  "MCQ Pratice - Media Queries OnDemand Session": Flexbox_On_Demand_Session_MCQ,
  "Introduction to CSS Flexbox": Introductionto_CSS_Flexbox,
  "Introduction to CSS Flexbox | Part 2": Introductionto_CSS_Flexbox_2,
 "Introduction to CSS Flexbox | Part 3":  Introductionto_CSS_Flexbox_3,
  "Sizing Elements and Handling Overflow": Sizing_Ele_Handling_Overflow,
  "Flexbox Coding Practice 1": Flexbox_Coding_Pratice_1,
  "Flexbox Coding Practice 2": Flexbox_Coding_Pratice_2,
  "Flexbox Coding Practice 3": Flexbox_Coding_Pratice_3,
  "Flexbox Coding Practice 4": Flexbox_Coding_Pratice_4,
  "Flexbox Coding Practice 5": Flexbox_Coding_Pratice_5,
  "Flexbox Coding Practice 6": Flexbox_Coding_Pratice_6,
  "Flexbox Coding Practice 7": Flexbox_Coding_Pratice_7,
  "Flexbox Coding Practice 8": Flexbox_Coding_Pratice_8,
  "Flexbox MCQ Assignment 1": Flexbox_MCQ_Assignment_1,
  "Flexbox MCQ Assignment 2": Flexbox_MCQ_Assignment_2,
  "Flexbox MCQ Assignment 3": Flexbox_MCQ_Assignment_3,
  "Flexbox MCQ Assignment 4": Flexbox_MCQ_Assignment_4,
  "Flexbox Coding Assignment 1": Flexbox_Coding_Assignment_1,
  "Flexbox Coding Assignment 2": Flexbox_Coding_Assignment_2,
  "Flexbox Coding Assignment 3": Flexbox_Coding_Assignment_3,
  "Flexbox Coding Assignment 4": Flexbox_Coding_Assignment_4,
  "Flexbox MCQ Test 1":  Flexbox_MockTest_1,
  "Flexbox MCQ Test 2":  Flexbox_MockTest_2,
  "Responsive Web Design Using Flexbox Course Exam | Instruction": Flexbox_Course_Exam_Instructions,
  "Responsive Web Design Using Flexbox Course Exam": Flexbox_Corse_Exam,
  //Js Essentials
  "JS Essential Coding Practice 1": JS_Essentials_Coding_Pratice_1,
  "JS Essential Coding Practice 2": JS_Essentials_Coding_Pratice_2,
  "JS Essential Coding Practice 3": JS_Essentials_Coding_Pratice_3,
  "JS Essential Coding Practice 4": JS_Essentials_Coding_Pratice_4,
  "JS Essential Coding Practice 5": JS_Essentials_Coding_Pratice_5,
  "JS Essential Coding Practice 6": JS_Essentials_Coding_Pratice_6,
  "JS Essential Coding Practice 7": JS_Essentials_Coding_Pratice_7,
  "JS Essential Coding Practice 8": JS_Essentials_Coding_Pratice_8,
  "JS Essential Coding Practice 9": JS_Essentials_Coding_Pratice_9,
  "JS Essential Coding Practice 10": JS_Essentials_Coding_Pratice_10,
  "JS Essential Coding Practice 11": JS_Essentials_Coding_Pratice_11,
  "JS Essentials Coding Assignment 1": JS_Essentials_Assignment_1,
  "JS Essentials Coding Assignment 2": JS_Essentials_Assignment_2,
  "JS Essentials Coding Assignment 3": JS_Essentials_Assignment_3,
  "JS Essentials Coding Assignment 4": JS_Essentials_Assignment_4,
  "JS Essentials Coding Test 1": JS_Essential_Mock_Coding_Test_1,
  "JS Essentials Coding Test 2": JS_Essential_Mock_Coding_Test_2,
  "More Modern JS Concepts | Part 1": More_Modern_JS_Concepts,
  "More Modern JS Concepts | Part 2": More_Modern_JS_Concepts_2,
  "More Modern JS Concepts | Part 3": More_Modern_JS_Concepts_3,
  "Factory and Constructor Function": Factory_Constructor_Function,
  "JS Promises": JS_Promises,
  "JS Promises 2": JS_Promises_2,
  "More JS Concepts": More_JS_Concepte,
  "Clean Code Guidelines": Clean_Code_Guidence,
  "JS Classes": JS_Classes,
  "Prototypal Inheritance": Prototypal_Inheritance,
  "JavaScript Essentials Course Exam | Instructions": JavaScript_Essentials_Course_Exam_Instruction,
  "JavaScript Essentials Course Exam": JavaScript_Essentials_Course_Exam,
  //Backend Interview set
  "JavaScript Practice Set - 1": JavaScript_Practice_Set_1,
  "JavaScript Practice Set - 2": JavaScript_Practice_Set_2,
  "JavaScript Practice Set - 3": JavaScript_Practice_Set_3,
  "JavaScript Practice Set - 4": JavaScript_Practice_Set_4,
  "Node Js Practice Set - 1": NodeJS_Practice_Set_1,
  "Node Js Practice Set - 2": NodeJS_Practice_Set_2,
  "Node Js Practice Set - 3": NodeJS_Practice_Set_3,
  "Node Js Practice Set - 4": NodeJS_Practice_Set_4,
  "React Js Practice Set - 1": ReactJs_Practice_Set_1,
  "React Js Practice Set - 2": ReactJs_Practice_Set_2,
  "React Js Practice Set - 3": ReactJs_Practice_Set_3,
  "React Js Practice Set - 4": ReactJs_Practice_Set_4,

  //Frontend Interview set
   "HTML Practice Set - 1":HTML_Practice_Set_1,
   "HTML Practice Set - 2": HTML_Practice_Set_2,
   "HTML Practice Set - 3": HTML_Practice_Set_3,
   "HTML Practice Set - 4": HTML_Practice_Set_4,
   "CSS Practice Set - 1": CSS_Practice_Set_1,
   "CSS Practice Set - 2": CSS_Practice_Set_2,
   "CSS Practice Set - 3": CSS_Practice_Set_3,
   "CSS Practice Set - 4": CSS_Practice_Set_4,
   "CSS Practice Set - 5": CSS_Practice_Set_5,
   "SQL Practice Set - 1": SQL_Practice_Set_1,
   "SQL Practice Set - 2": SQL_Practice_Set_2,
   "SQL Practice Set - 3": SQL_Practice_Set_3,
   "SQL Practice Set - 4": SQL_Practice_Set_4,
   "Python Practice Set - 1": Python_Practice_Set_1,
   "Python Practice Set - 2": Python_Practice_Set_2,
   "Python Practice Set - 3": Python_Practice_Set_3,
   "Python Practice Set - 4": Python_Practice_Set_4,
   "Bootstrap Practice Set - 1": Bootstrap_Practice_set,

  //Git
  "Understanding Binary": Understaing_Binary,
  "Overview of Computer Hardware": OverViewof_Hardware,
  "Introduction to Operating Systems": Introductionto_Operating_System,
  "Overview of Process Management": Process_Managent,
  "Threads and Concurrency": Threads_Courrency,
  "Memory Management": Memory_Managent,
  "Application Layer": Application_Layer,
  "Network Layer": Network_Layer,
  "Transport Layer": Transport_Layers,
  "Getting Started with Command Line": Working_Command_Line,
  "Google Cloud Shell": Google_Cloud_Sheel,
  "Working with File System": Working_File_System,
  "Working with Files": Working_with_Files,
  "Miscellaneous Commands - 1": Miscellaneous_Commands_1,
  "Miscellaneous Commands - 2": Miscellaneous_Commands_2,
  "Getting Started with Git": Getting_Started_Git,
  "Staging Area and Commits": Staging_Area_Commits,
  "Setting Up WSL2":SettingUp_WSL2,
  "Developer Foundations Course Exam | Instructions": Developer_Foundations_Course_Exam_Instructions,
"Developer Foundations Course Exam": Developer_Foundations_Course_Exam,

  //Reactjs class & codingPratices
 "React Js Course Exam | Instructions": React_Course_Exam_Instructions,
 "React Js Course Exam":  React_Course_Exam,
 "Introduction to React JS": Introductionto_Reactjs,
  "Components & Pros": Components_Props,
  "Lists & Keys": List_Keys,
  "Class Component and State": Class_Component_State1,
  "A Note on React Versions": Noteon_React_Versions,
  "Conditional Rendering": Conditional_Render,
  "Class Component and State | Part 2": Class_Component_State2, 
  "Common Mistakes": Common_Mistakes,
  "Debugging using Developer Tools": Debugging_Dev_Tools,
  "On Demand Session | Part 1": Ondemand_Sessions_Part1,
  "On Demand Session | Part 2": Ondemand_sessions_part2,
  "Component Life Cycle": Component_Life_Cycle,
  "Routing using React Router": React_Router1,
  "Routing using React Router | Part 2": React_Router2,
  "Routing using React Router | Part 3": React_Router3,
  "Common Mistakes | Part 2": Common_M_Part_2,
  "Authentication & Authorization": Authentication,
  "Authentication & Authorization | Part 2": Authentication_2,
  "Authentication & Authorization | Part 3": Authentication_3,
  "Authentication & Authorization | Part 4": Authentication_P4,
  "Sorting Products": SortingProducts,
  "More React Concepts": More_React,
  "Third Party Packages": Third_Party,
  "React Context": React_Context_1,
  "React Context | Part 2":React_Context_2,
  "React Context | Part 3": React_Context_3,
  "React Context | Part 4": React_Context_4,
  "Styled Components": Styled_Components,
  "ReactJs Coding Pratice 1": React_Coding_Practice_1,
  "ReactJs Coding Pratice 2": React_Coding_Practice_2,
  "ReactJs Coding Pratice 3": React_Coding_Practice_3,
  "ReactJs Coding Practice 4": React_Coding_Practice_4,
  "ReactJs Coding Practice 5": React_Coding_Practice_5,
  "ReactJs Coding Practice 6": React_Coding_Practice_6,
  "ReactJs Coding Practice 7": React_Coding_Practice_7,
  "ReactJs Coding Practice 8":React_Coding_Practice_8,
  "React Assignment 1": React_Assignment_1,
  "React Assignment 2": React_Assignment_2,
  "React Assignment 3": React_Assignment_3,
  "React Assignment 4": React_Assignment_4,
  "React Assignment 5": React_Assignment_5,
  "React Assignment 6": React_Assignment_6,
  "React Assignment 7": React_Assignment_7,
  "ReactJs Coding Practice 9": React_Coding_Practice_9,
  "ReactJs Coding Practice 10":  React_Coding_Practice_10,
  "ReactJs Coding Practice 11": React_Coding_Practice_11,
  "ReactJs Coding Practice 12": React_Coding_Practice_12,
  "ReactJs Coding Practice 13": React_Coding_Practice_13,
  "ReactJs Coding Practice 14": React_Coding_Practice_14,
  "ReactJs Coding Practice 15": React_Coding_Practice_15,
  "ReactJs Coding Practice 16": React_Coding_Practice_16,
  "ReactJs Coding Practice 17": React_Coding_Practice_17,
  "ReactJs Coding Practice 18": React_Coding_Practice_18,
  "ReactJs Coding Practice 19": React_Coding_Practice_19,
  "ReactJs Coding Practice 20": React_Coding_Practice_20,
  "ReactJs Coding Practice 21": React_Coding_Practice_21,
  "ReactJs Coding Practice 22": React_Coding_Practice_22,
  "ReactJs Coding Practice 23": React_Coding_Practice_23,
  "ReactJs Coding Practice 24": React_Coding_Practice_24,
  "ReactJs Coding Practice 25": React_Coding_Practice_25,
  "ReactJs Coding Practice 26": React_Coding_Practice_26,
  "ReactJs Coding Practice 27": React_Coding_Practice_27,
  "ReactJs Coding Practice 28": React_Coding_Practice_28,
  "ReactJs Coding Practice 29": React_Coding_Practice_29,
  "ReactJs Coding Practice 30": React_Coding_Practice_30,
  "ReactJs Coding Practice 31": React_Coding_Practice_31,
  "ReactJs Coding Practice 32": React_Coding_Practice_32,
  "ReactJs Coding Practice 33": React_Coding_Practice_33,
  "ReactJs Coding Practice 34": React_Coding_Practice_34,
  "ReactJs Coding Practice 35": React_Coding_Practice_35,
  "ReactJs Coding Practice 36": React_Coding_Practice_36,
  "ReactJs Coding Practice 37": React_Coding_Practice_37,
  "ReactJs Coding Practice 38": React_Coding_Practice_38,
  "ReactJs Coding Practice 39": React_Coding_Practice_39,
  "ReactJs Coding Practice 40": React_Coding_Practice_40,
  "ReactJs Coding Practice 41": React_Coding_Practice_41,
  "ReactJs Coding Practice 42": React_Coding_Practice_42,
  "ReactJs Coding Practice 43": React_Coding_Practice_43,
  "ReactJs Coding Practice 44": React_Coding_Practice_44,
  "ReactJs Coding Practice 45": React_Coding_Practice_45,
  "Interview Mock Test 1A": Interview_Mock_Test_1A,
  "Interview Mock Test 1B": Interview_Mock_Test_1B,
  "Interview Mock Test 1C": Interview_Mock_Test_1C,
  "Interview Mock Test 1D": Interview_Mock_Test_1D,
  "Interview Mock Test 1E": Interview_Mock_Test_1E,
  
  //Nodejs
  "MERN Stack":Mern_Stack,
  "Introduction to Node JS": Introductionto_Nodejs,
  "Introduction to Node JS | Part 2":Introductionto_Nodejs_2,
  "NodeJS Coding Practice 1": Nodejs_Coding_Pratice_1,
  "NodeJS Coding Practice 2": Nodejs_Coding_Pratice_2,
  "Hypertext Transfer Protocol": Node_Hyper_Text_Transfer_Protocal,
  "Introduction to Express JS": Introductionto_Expressjs,
  "Introduction to Express JS | Part 2": Introductionto_Expressjs_2,
  "Introduction to Express JS | Part 3": Introductionto_Expressjs_3,
  "Debugging Common Errors": Debug_Cmmn_Errors,
  "Debugging Common Errors | Part 2": Debug_Cmmn_Errors_P2,
  "REST APIs":Rest_APIs,
  "Authentication | Part 1": Athantication_1,
  "Authentication | Part 2": Athantication_2,
  "Authentication | Part 3": Athantication_3,
  "NodeJS Coding Practice 3": Nodejs_Coding_Pratice_3,
  "NodeJS Coding Practice 4": Nodejs_Coding_Pratice_4,
  "NodeJS Coding Practice 5": Nodejs_Coding_Pratice_5,
  "NodeJS Coding Practice 6": Nodejs_Coding_Pratice_6,
  "NodeJS Coding Practice 7": Nodejs_Coding_Pratice_7,
  "NodeJS Coding Practice 8": Nodejs_Coding_Pratice_8,
  "NodeJS Coding Practice 9": Nodejs_Coding_Pratice_9,
  "NodeJS Coding Practice 10": Nodejs_Coding_Pratice_10,
  "Nodejs Assignment 1": Nodejs_Coding_Assignmet_1,
  "Nodejs Assignment 2": Nodejs_Coding_Assignmet_2,
  "Nodejs MCQ Test 1":Nodejs_Mock_Test_1,
  "Nodejs MCQ Test 2":Nodejs_Mock_Test_2,
  "Nodejs MCQ Test 3":Nodejs_Mock_Test_3,
  "Nodejs Course Exam | Instructions": Nodejs_Course_exam_Instructions,
  "Nodejs Course Exam": Nodejs_Course_Exam,

  //Python OOPS CORE
  "Foundations of Object Oriented Programming | Cheat Sheet":
    FoundationsOfOOP_CheatSheet,
  "Foundations of Object Oriented Programming | Cheat Sheet 2":
    FoundationsOfOOP_CheatSheet_2,
  "Python Coding Practice 32": FoundationsOfOOP_Coding_Pratice,
  "Standard Library | Cheat Sheet": Miscellaneous_Python_Library_CheeatSheet,
  "MCQ Practice - Standard Library": Miscellaneous_Python_Library_MCQ,
  "Python Coding Practice 33": Miscellaneous_Python_Library_Coding_Pratice,
  //SQL Coding Pratice
  "SQL Coding Practice 1": SQL_Coding_Pratice_1,
  "SQL Coding Practice 2": SQL_Coding_Pratice_2,
  "SQL Coding Practice 3": SQL_Coding_Pratice_3,
  "SQL Coding Practice 4": SQL_Coding_Pratice_4,
  "SQL Coding Practice 5": SQL_Coding_Pratice_5,
  "SQL Coding Practice 6": SQL_Coding_Pratice_6,
  "SQL Coding Practice 7": SQL_Coding_Pratice_7,
  "SQL Coding Practice 8": SQL_Coding_Pratice_8,

  // JavaScript Essentials
  "More Modern JS Concepts | Cheat Sheet": More_Modern_JS_Concepts_CS,
  "MCQ Practice - More Modern JS Concepts": More_Modern_Js_Concepts_MCQ,
  "More Modern JS Concepts | Part 2 | Cheat Sheet":
    More_Modern_JS_Concepts_CS_2,
  "MCQ Practice - More Modern JS Concepts | Part 2":
    More_Modern_JS_Concepts_MCQ_2,
  "Factory and Constructor Function | Cheat Sheet":
    Factory_Constructor_Function_CS,
  "MCQ Practice - Factory and Constructor Function":
    Factory_Constructor_Function_MCQ,
  "More Modern JS Concepts | Part 3 | Cheat Sheet":
    More_Modern_JS_Concepts_CS_3,
  "MCQ Practice - More Modern JS Concepts | Part 3":
    More_Modern_JS_Concepts_MCQ_3,
  "Prototypal Inheritance | Cheat Sheet": Prototypal_Inheritance_CS,
  "MCQ Practice - Prototypal Inheritance": Prototypal_Inheritance_MCQ,
  "JS Classes | Cheat Sheet": JS_Classes_CS,
  "MCQ Practice - JS Classes": JS_Classes_MCQ,
  "JS Promises | Cheat Sheet": JS_Promises_CS,
  "MCQ Practice - JS Promises": JS_Promises_MCQ,
  "JS Promises | Part 2 | Cheat Sheet": JS_Promises_CS_2,
  "MCQ Practice - JS Promises | Part 2": JS_Promises_MCQ_2,
  "More JS Concepts | Cheat Sheet": More_JS_Conceptes_CS,
  "MCQ Practice - More JS Concepts": More_JS_Concepte_MCQ,
  // "Authentication & Authorization":
  // "Authentication & Authorization | Part 2":
  // "Authentication & Authorization | Part 3":
  // "Common Mistakes | Part 3":
  "JS Essentials MCQ Assignment 1": JS_Essential_MCQ_Assignment_1,
  "JS Essentials MCQ Assignment 2": JS_Essential_MCQ_Assignment_2,
  "JS Essentials MCQ Assignment 3": JS_Essential_MCQ_Assignment_3,
  "JS Essentials MCQ Assignment 4": JS_Essential_MCQ_Assignment_4,
  "JS Essentials Mock Test 1": JS_Essential_Mock_Tests_MCQ_1,
  "JS Essentials Mock Test 2": JS_Essential_Mock_Tests_MCQ_2,
  //SQL Database
  "Introduction to Databases | Part 1": Introductionto_Database_1,
  "Introduction to Databases | Part 2": Introductionto_Database_2,
  "Introduction to Databases | Cheat Sheet": Introduction_to_Databases_CS,
  "MCQ Practice Introduction to Databases": Introductionto_Database_MCQ,
  "Introduction to SQL | Part 1": Introductionto_SQL_1,
  "Introduction to SQL | Part 2": Introductionto_SQL_2,
  "Platform Walkthrough": SQL_Platform_Walkthrough,
  "Create Table Cheat Sheet": Create_Table_CS,
  "Inserting Rows Cheat Sheet": Inserting_Row_CS,
  "Retrieving Data Cheat Sheet": Retrieving_Data_CS,
  "Update Rows Cheat Sheet": Update_Rows_CS,
  "Delete Rows Cheat Sheet": Delete_Rows_CS,
  "Alter Table Cheat Sheet": Alter_Table_CS,
  "MCQ Practice - Introduction to SQL | Part 1": Introductionto_SQL_MCQ_1,
  "MCQ Practice - Introduction to SQL | Part 2": Introductionto_SQL_MCQ_2,
  "Common Mistakes | Reading Material": Common_Mistakes_RM_CS,
  "Comparison Operators Cheat Sheet": Comparison_Operators_CS,
  "String Operations Cheat Sheet": String_Operators_CS,
  "Logical Operators Cheat sheet": Logical_Operators_CS,
  "MCQ Practice - Common Mistakes | Reading Material": Common_Mistakes_RM_MCQ,
  "Querying with SQL | Part 1": Quering_SQL_1,
  "MCQ Practice Querying with SQL | Part 1": Quering_SQL_MCQ_1,
  "Querying with SQL | Part 2": Quering_SQL_2,
  "MCQ Practice Querying with SQL | Part 2": Quering_SQL_MCQ_2,
  "Querying with SQL | Part 3": Quering_SQL_3,
  "Querying with Joins | Part 3 | Cheat Sheet": Quering_with_Joins_CS_Part_3,
  "MCQ Practice Querying with SQL | Part 3": Quering_SQL_MCQ_3,
  "In and Between Operators Cheat Sheet": In_Between_Operators_CS,
  "Order By Distinct Cheat Sheet": Order_By_Distinct_CS,
  "Pagination Cheat Sheet": Pagination_CS,
 "Aggregations": Aggregations,
  "Aggregations | Cheat Sheet": Aggregations_CS,
  "MCQ Practice - Aggregations": Aggregations_MCQ,
  "Group By": Group_By,
  "Group By with Having": Group_By_Having,
  "Group By with Having | Cheat Sheet": Group_By_Having_CS,
  "MCQ Pratice - Group By with Having": Groupby_Having_MCQ,
  "MCQ Practice Common Concepts": Common_Concepte_MCQ,
  "Common Concepts": Common_Concepts_Class,
  "SQL Expression | Cheat Sheet": SQL_Expression_Cs,
  "SQL Functions | Cheat Sheet": SQL_Functions_CS,
  "Cast Functions | Cheat Sheet": Cast_Functions_CS,
  "Arthmetic Functions | Cheat Cheet": Arthmetic_Functions_CS,
  "SQL Case | Cheat Sheet": SQL_Case_CS,
  "SQL Set Operations | Cheat Sheet": SQL_Set_Operations_CS,
  // "Coding Practice 5": Coding_Pratice_5,
  "MileStone | Cheat Sheet": Milestone_CS,
  "MCQ Practice MileStone": Milestone_MCQ,
  "SQL Assignment 1": SQL_Assignment_1,
  "SQL Assignment 2": SQL_Assignment_2,
  "Modelling Database | Part 1": Modelling_Database_Class_1,
  "Core Concepts of ER Model | Cheat Sheets": Core_Concepts_ER_CS,
  "Appliying ER Model Concepts | Cheat Sheets": Applying_ER_Model_Concepts_CS,
  "ER Model to Relational Database | Cheat Sheets": ER_Model_Relational_DB,
  "MCQ Practice Modelling Database | Part 1": Modelling_Database_MCQ,
  "Modelling Database | Part 2": Modelling_Database_Class_2,
  "Createing a Relational Database | Cheat Sheets": Creating_Relation_DB_CS,
  "MCQ Practice Modelling Database | Part 2": Creating_Relational_DB_MCQ,
  "Joins | Part 1": Joins_Class_Part_1,
  "Joins | Part 1 | Cheat Sheet": Joins_Part_1_Cs,
  "MCQ Practice Joins": Joins_MCQ,
  "Querying with Joins | Part 2": Quering_with_Joins_Class_Part_2,
  "Querying with Joins | Part 2 | Cheat Sheet": Quering_with_Joins_CS_Part_2,
  "MCQ Practice Querying with Joins | Part 2": Quering_with_Joins_Part_2_MCQ,
  "Querying with Joins | Part 3": Quering_with_Joins_Class_Part_3,
  "MCQ Practice Querying with Joins | Part 3": Quering_with_Joins_MCQ_Part_3,
  "SQL Coding Practice 9": Joins_Coding_Pratice_1,
  "SQL Coding Practice 10": Joins_Coding_Pratice_2,
  "SQL Coding Practice 11": Joins_Coding_Pratice_3,
  "SQL Coding Practice 12": Joins_Coding_Pratice_4,
  "Views and Subqueries": Views_And_Subqueries,
  "Views Subqueries | Cheat Sheet": Views_And_Subqueries_CS,
  "Subqueries | Cheat Sheet": Subqueries_CS,
  "MCQ Practice Views and Subqueries": Views_And_Subqueries_MCQ,
  "SQL Coding Practice 13": View_Subqeries_Coding_Pratice_11,
  "Transaction and Indexes": Transaction_Indexes_Class,
  "Transaction and Indexes | Cheat Sheet": Transaction_Indexes_CS,
  "MCQ Practice Transaction and Indexes": Transaction_Indexes_MCQ,
  "SQL Syntax Differences Between SQLite, MySQL, and Oracle":
    SQL_Syntax_Differences,

  "SQL Assignment 3": SQL_Assignment_3,
  "MCQ Exam 1": MCQ_Exam_1,

  //Responsive Website
  "Introduction to Responsive Web Design": Introductionto_Responsive_WD_1,
  "MCQ Practice - Res_WD": Introductionto_Responsive_WD_MCQ,
  "BootStrap Grid System Part 1": Bootstrap_Grid_Sys_1,
  "MCQ Practice - B_GS_1": Bootstrap_Grid_Sys_MCQ_1,
  "BootStrap Grid System Part 2": Bootstrap_Grid_Sys_2,
  "MCQ Practice - B_GS_2": Bootstrap_Grid_Sys_MCQ_2,
  "BootStrap Navbar": Bootstrap_Navbar_1,
  "MCQ Practice - B_Nav": Bootstrap_Navbar_MCQ,
  "CSS Selectors & Inheritance": Css_Selector_Inheritance_1,
  "MCQ Practice - CSS Selectors & Inheritance": Css_Selector_Inheritance_MCQ,
  "CSS Specificity & Cascade": Css_Specificity_Cascade_1,
  "MCQ Practice - CSS Specificity & Cascade": Css_Specificity_Cascade_MCQ,
  "Banner Section": Banner_Section_1,
  "MCQ Practice - Banner Section": Banner_Section_MCQ,
  "Why Choose Us? Section": Why_Chooseus_Section_1,
  "MCQ Practice - Why Choose Us Section": Why_Chooseus_Section_MCQ,
  "Explore New Section": Explore_Menu_Section_1,
  "MCQ Practice - Explore Menu Section": Explore_Menu_Section_MCQ,
  "Healthy Food, Delivery and Payment, Thanking Customers Section":
    Healthy_Delivary_Payments_1,
  "MCQ Practice - Healthy Delivery & Payments": Healthy_Delivary_Payments_MCQ,
  "Follow Us Section & More Styling": Followus_More_Styles_1,
  "MCQ Practice - Follow_us": Followus_More_Styles_MCQ,
  "CSS Gradients & More BootStrap Components": Css_Gradience_1,
  "MCQ Practice - CSS_Gradients": CSS_Gradience_MCQ,
  "Responsive MCQ Assignment 1": Responsive_MCQ_Assignments_1,
  "Responsive MCQ Assignment 2": Responsive_MCQ_Assignments_2,
  "Responsive MCQ Assignment 3": Responsive_MCQ_Assignments_3,
  "Responsive Coding Practice 1": Responsive_Coding_Pratice_1,
  "Responsive Coding Practice 2": Responsive_Coding_Pratice_2,
  "Responsive Coding Practice 3": Responsive_Coding_Pratice_3,
  "Responsive Coding Practice 4": Responsive_Coding_Pratice_4,
  "Responsive Coding Practice 5": Responsive_Coding_Pratice_5,
  "Responsive Coding Practice 6": Responsive_Coding_Pratice_6,
  "Responsive Coding Practice 7": Responsive_Coding_Pratice_7,
  "Responsive Coding Practice 8": Responsive_Coding_Pratice_8,
  "Responsive Coding Practice 9": Responsive_Coding_Pratice_9,
  "Responsive Coding Practice 10": Responsive_Coding_Pratice_10,
  "Responsive Coding Practice 11": Responsive_Coding_Pratice_11,
  "Responsive Coding Practice 12": Responsive_Coding_Pratice_12,
  "Responsive Coding Practice 13": Responsive_Coding_Pratice_13,
  "Responsive Coding Practice 14": Responsive_Coding_Pratice_14,
  "Responsive Coding Practice 15": Responsive_Coding_Pratice_15,
  "Responsive Coding Practice 16": Responsive_Coding_Pratice_16,
  "Responsive Coding Assignment 1": Responsive_Coding_Assignment_1,
  "Responsive Website Project": Responsive_Coding_Assignment_2,
  "Responsive Coding Assignment 3": Responsive_Coding_Assignment_3,
  "Reponsive Coding Test 1": Responsive_Coding_Test_1,
  "Responsive Coding Test 2": Responsive_Coding_Test_2,
  "Responsive Coding Test 3": Responsive_Coding_Test_3,
  "Build Your Own Responsive Project": Responsive_Project,
  "Build Your Own Responsive Website Course Exam | Instructions":
    Responsive_Course_Exam_Instructions,
  "Build Your Own Responsive Website Course Exam": Responsive_Course_Exam,

  //Responsive Start
  "Introduction to Responsive Web Design | Cheat Sheet":
    Introductionto_Responsive_WD_CS,
  "BootStrap Grid System Part 1 | Cheat Sheet": Bootstrap_Grid_Sys_CS_1,
  "BootStrap Grid System Part 2 | Cheat Sheet": Bootstrap_Grid_Sys_CS_2,
  "BootStrap Navbar | Cheat Sheet": Bootstrap_Navbar_CS,
  "CSS Selectors & Inheritance | Cheat Sheet": Css_Selector_Inheritance_CS,
  "CSS Specificity & Cascade | Cheat Sheet": Css_Specificity_Cascade_CS,
  "Banner Section | Cheat Sheet": Banner_Section_CS,
  "Explore New Section | Cheat Sheet": Explore_Menu_Section_CS,
  "Healthy Food, Delivery and Payment, Thanking Customers Section | Cheat Sheet":
    Healthy_Delivary_Payments_CS,
  "Why Choose us? Section | Cheat Sheet": Why_Chooseus_Section_CS,
  "CSS Gradients & More BootStrap Components | Cheat Sheet": CSS_Gradience_CS,
  "Follow Us Section & More Styling | Cheat Sheet": Followus_More_Styles_CS,
  "Responsive Summary CheatSheet": Responsive_Summary_CS,

  //Responsive End

  //Static Website Class
  "Coding Platform Walk through": Coding_Practice_Platform_Walkthrough,
  "A Note on BootStrap Versions": A_Note_ON_BootStrap_Version_Class,
  "Website: Behind the Scenes": Website_Behind_the_Scenes,
  "Introduction to Your First Project - Lets Build Together":
    Introductionto_First_Project,
  "Introduction to HTML": Introductionto_Html,
  "Introduction to CSS Part 1": Introductionto_Css_1,
  "Introduction to CSS Part 2": Introductionto_Css_2,
  "Introduction to CSS Part 3": Introductionto_Css_3,
  "Introduction to CSS Box Model Part 1": Introductionto_Css_Boxmodel_1,
  "Introduction to CSS Box Model Part 2": Introductionto_Css_Boxmodel_2,
  "Introduction to Bootstrap Part 1": Introductionto_Bootstrap_1,
  "Introduction to Bootstrap Part 2": Introductionto_Bootstrap_2,
  "Favourite Places Section": FavouritePlaces_Section_1,
  "Approach to Develop a Layout": Approachto_Develop_Layout_1,
  "Favourite Place Detailed View Section": Favouriteplaces_Detailview_1,
  "Website Integration Part 1": WebSite_Integration_1,
  "Website Integration | Part 2": WebSite_Integration_2,
  "HTML Hyperlinks": Html_HyperLinks_1,
  "Hyperlinks OnDemand Session": OnDemand_Session_1,
  "Static Coding Assignment 1": Static_Coding_Assignment_1,
  "Static Coding Assignment 2": Static_Coding_Assignment_2,
  "Static Coding Assignment 3": Static_Coding_Assignment_3,
  "Static Coding Practice 1": Static_Coding_Pratice_1,
  "Static Coding Practice 2": Static_Coding_Pratice_2,
  "Static Coding Practice 3": Static_Coding_Pratice_3,
  "Static Coding Practice 4": Static_Coding_Pratice_4,
  "Static Coding Practice 5": Static_Coding_Pratice_5,
  "Static Coding Practice 6": Static_Coding_Pratice_6,
  "Static Coding Practice 7": Static_Coding_Pratice_7,
  "Static Coding Practice 8": Static_Coding_Pratice_8,
  "Static Coding Test 1": Static_Mock_Test_1,
  "Static Coding Test 2": Static_Mock_Test_2,
  "Build Your Own Static Website Project": Static_Website_Project,
  "Build Your Own Static Website Course Exam | Instructions":
    Static_Course_Exam_Instruction,
  "Build Your Own Static Website Course Exam": Static_Course_Exam,
  "Introduction to HTML | Cheat Sheet": Introductionto_HTML_CS_1,
  "MCQ Practice - HTML": Introductionto_HTML_MCQ,
  "Introduction to CSS Part 1 | Cheat Sheet": Introductionto_Css_CS_1,
  "MCQ Practice - CSS 1": Introductionto_Css_MCQ_1,
  "Introduction to CSS Part 2 | Cheat Sheet": Introductionto_Css_CS_2,
  "MCQ Practice - CSS 2": Introductionto_Css_MCQ_2,
  "Introduction to CSS Part 3 | Cheat Sheet": Introductionto_Css_CS_3,
  "MCQ Practice - CSS 3": Introductionto_Css_MCQ_3,
  "Introduction to CSS Box Model Part 1 | Cheat Sheet":
    Introductionto_Css_BoxModel_CS_1,
  "MCQ Practice - BoxModel 1": Introductionto_Css_BoxModel_MCQ_1,
  "Introduction to CSS Box Model Part 2 | Cheat Sheet":
    Introductionto_Css_BoxModel_CS_2,
  "MCQ Practice - BoxModel 2": Introductionto_Css_BoxModel_MCQ_2,
  "Introduction to Bootstrap Part 1 | Cheat Sheet":
    Introductionto_BootStrap_CS_1,
  "MCQ Practice - Bootstrap 1": Introductionto_BootStrap_MCQ_1,
  "Introduction to Bootstrap Part 2 | Cheat Sheet":
    Introductionto_BootStrap_CS_2,
  "MCQ Practice - Bootstrap 2": Introductionto_BootStrap_MCQ_2,
  "Approach to Develop a Layout | Cheat Sheet": Approachto_Develop_Layout_CS_1,
  "MCQ Practice - Layout 2": Approachto_Develop_Layout_MCQ_2,
  "Favourite Place Detailed View Section | Cheat Sheet":
    FavouritePlaces_DetailView_CS,
  "MCQ Practice - Layout 3": FavouritePlaces_DetailedView_MCQ_3,
  "Favourite Places Section | Cheat Sheet": FavouritePlaces_Section_CS_1,
  "MCQ Practice - Layout 1": FavouritePlaces_Section_MCQ_1,
  "OnDemand Session | Cheat Sheet": OnDemand_Session_CS,
  "MCQ Practice - OnDemand": OnDemand_Session_MCQ,
  "Hypertext Transfer Protocol (HTTP) | Cheat Sheet":
    Hypertext_Transfer_Protocal_CS,
  "Forms | Part 2 | Cheat sheet": Forms_CS_2,
  "HTML Hyperlinks | Cheat Sheets": HTML_HyperLinks_CS,
  "MCQ Practice - HTML Hyperlinks": HTML_HyperLinks_MCQ,
  "Website Integration Part 1 | Cheat Sheet": Website_Integration_CS_1,
  "MCQ Practice - Website 1": Website_Integration_MCQ_1,
  "Website Integration Part 2 | Cheat Sheet": Website_Integration_CS_2,
  "MCQ Practice - Website 2": Website_Integration_MCQ_2,
  "Static Summary CheatSheet": StaticSummary_CS,
  "Static MCQ Assignment 1": Static_MCQ_Assignment1,
  "Static MCQ Assignment 2": Static_MCQ_Assignment2,
  "Static MCQ Assignment 3": Static_MCQ_Assignment3,
  "Static MCQ Assignment 4": Static_MCQ_Assignment4,
  //Static End

  //Python Coding & Class
  "Coding Practice Walkthrough | Part 1": Coding_Pratice_Walkthough,
  "Input and Output Basics": Inp_Oup_Basics_Class,
  "Type Conversion": Type_Con_Class,
  "Programming with Python": Pro_W_P_Class,
  "Variables and Data Types": Variables_DT_Class,
  "Sequence of Instructions": Seq_Of_Instruction_Class,
  "Coding Practice 1A": Coding_Pratice_1A,
  "Coding Practice 1B": Coding_Pratice_1B,
  "Coding Practice 1C": Coding_Pratice_1C,
  "Coding Practice 1D": Coding_Pratice_1D,
  "Coding Practice 1E": Coding_Pratice_1E,
  "Coding Practice 1F": Coding_Pratice_1F,
  "Assignment 1A": Assignment_1A,
  "Assignment 1B": Assignment_1B,
  "Relational Operators": Relationoperator_Class,
  "Logical Operators": Logicaloperators_Class,
  "Conditional Statements": Conditionalstmts_Class,
  "Coding Practice 2A": Coding_Pratice_2A,
  "Coding Practice 2B": Coding_Pratice_2B,
  "Assignment 2A": Assignment_2A,
  "Coding Practice 2C": Coding_Pratice_2C,
  "Coding Practice 2D": Coding_Pratice_2D,
  "Coding Practice 2E": Coding_Pratice_2E,
  "Assignment 2B": Assignment_2B,
  "Coding Practice 3A": Coding_Pratice_3A,
  "Coding Practice 3B": Coding_Pratice_3B,
  "Assignment 3": Assignment_3A,
  "Problem Solving and Debugging Part 2": ProblemSol_Debugging_Class_2,
  "Problem Solving and Debugging Part 1": ProblemSol_Debugging_Class_1,
  "Nested Conditional Statements": Nested_con_Class,
  "Coding Practice 4A": Coding_Pratice_4A,
  "Coding Practice 4B": Coding_Pratice_4B,
  "Assignment 4": Assignment_4,
  // "Coding Practice 5": Python_Coding_Pratice_5,
  "Assignment 5": Assignment_5,
  "Coding Practice 6A": Coding_Pratice_6A,
  "Coding Practice 6B": Coding_Pratice_6B,
  "Assignment 6": Assignment_6,
  "Grand Assignment 1": Grand_Assignment_1,
  Loops: Loops_Class,
  "For Loop": FoorLoop_Class,
  "Problem Solving Part 1": Problem_Solving_Part_1_Class,
  "Problem Solving Part 2": Problem_Solving_Part_2_Class,
  "Problem Solving Part 3": Problem_Solving_Part_3_Class,
  "Problem Solving Part 4": Problem_Solving_Part_4_Class,
  "String Methods": String_Methods_Class,
  "Assignment 7": Assignment_7,
  "Assignment 8": Assignment_8,
  "Assignment 9": Assignment_9,
  "Assignment 10A": Assignment_10A,
  "Assignment 10B": Assignment_10B,
  "Assignment 11": Assignment_11,
  "Coding Practice 7A": Coding_Pratice_7A,
  "Coding Practice 7B": Coding_Pratice_7B,
  "Coding Practice 8A": Coding_Pratice_8A,
  "Coding Practice 8B": Coding_Pratice_8B,
  "Coding Practice 9A": Coding_Pratice_9A,
  "Coding Practice 9B": Coding_Pratice_9B,
  "Coding Practice 10A": Coding_Pratice_10A,
  "Coding Practice 10B": Coding_Pratice_10B,
  "Coding Practice 10C": Coding_Pratice_10C,
  "Coding Practice 10D": Coding_Pratice_10D,
  "Coding Practice 10E": Coding_Pratice_10E,
  "Coding Practice 10F": Coding_Pratice_10F,
  "Coding Practice 11A": Coding_Pratice_11A,
  "Coding Practice 11B": Coding_Pratice_11B,
  "Foundations Exam 1": Fundations_Exam_1,
  "Problem Solving and Debugging Part 3": ProblemSol_Debugging_Class_3,
  "Coding Practice 12": Coding_Pratice_12,
  "Assignment 12": Assignment_12,
  "Nested Loops": NestedLoops_Class,
  "Problem Solving Part 5": Problem_Solving_Part_5_Class,
  "Problem Solving Part 6": Problem_Solving_Part_6_Class,
  "Coding Practice 13A": Coding_Pratice_13A,
  "Coding Practice 13B": Coding_Pratice_13B,
  "Assignment 13": Assignment_13,
  "Problem Solving Part 7": Problem_Solving_Part_7_Class,
  "Coding Practice 14A": Coding_Pratice_14A,
  "Coding Practice 14B": Coding_Pratice_14B,
  "Assignment 14": Assignment_14,
  "Coding Practice 15A": Coding_Pratice_15A,
  "Coding Practice 15B": Coding_Pratice_15B,
  "Loop Control Statements": LoopControlStmts_Class,
  "Coding Practice 16": Coding_Pratice_16,
  "Assignment 16": Assignment_16,
  "Grand Assignment 2": Grand_Assignment_2,
  "Comparing Strings & Naming Variables": ComparigStr_NamingVar_Class,
  "Problem Solving and Debugging Part 4": ProblemSol_Debugging_Class_4,
  "Problem Solving and Debugging Part 5": ProblemSol_Debugging_Class_5,
  "Coding Practice 17A": Coding_Pratice_17A,
  "Coding Practice 17B": Coding_Pratice_17B,
  "Coding Practice 18": Coding_Pratice_18,
  "Coding Practice 19": Coding_Pratice_19,
  "Assignment 17": Assignment_17,
  "Assignment 18": Assignment_18,
  "Assignment 19": Assignment_19,
  Lists: List_Class,
  "Working with Lists": Workingwith_List_Class,
  "Coding Practice 20": Coding_Pratice_20,
  "Assignment 20": Assignment_20,
  "Coding Practice 21A": Coding_Pratice_21A,
  "Coding Practice 21B": Coding_Pratice_21B,
  "Coding Practice 22A": Coding_Pratice_22A,
  "Coding Practice 22B": Coding_Pratice_22B,
  "Coding Practice 23A": Coding_Pratice_23A,
  "Coding Practice 23B": Coding_Pratice_23B,
  "List & Strings": Lists_String_Class,
  "Assignment 21": Assignment_21,
  "Assignment 22": Assignment_22,
  "Assignment 23": Assignment_23,
  Functions: Functions_Class,
  "Foundations Exam 2": Fundations_Exam_2,
  "Function Arguments": Function_Argu_Class,
  "Built in Functions": Built_in_Fun_Class,
  "Function Call Stack & Recursion": FunCallStack_Recursion_Class,
  "List Methods": ListMethods_Class,
  "Assignment 24": Assignment_24,
  "Assignment 25": Assignment_25,
  "Assignment 26": Assignment_26,
  "Coding Practice 24": Coding_Pratice_24,
  "Coding Practice 25": Coding_Pratice_25,
  "Coding Practice 26": Coding_Pratice_26,
  "Python Standard Library": Python_Standard_Library_Class,
  "Tuples & Sequences": Tuples_Sequences_Class,
  Sets: Sets_Class,
  "Set Operations": Set_Operations_Class,
  "Coding Practice 27": Coding_Pratice_27,
  "Problem Solving and Debugging Part 6": ProblemSol_Debugging_Class_6,
  "Nested Lists & String Formatting": NestedList_StringFormating_Class,
  Dictionaries: Dictionaries_Class,
  "Working with Dictionaries": Working_With_Dictionaries_Class,
  "Coding Practice 28": Coding_Pratice_28,
  "Coding Practice 29": Coding_Pratice_29,
  "Coding Practice 30": Coding_Pratice_30,
  "Coding Practice 31": Coding_Pratice_31,
  "Grand Assignment 3": Grand_Assignment_3,
  "Grand Assignment 4": Grand_Assignment_4,
  "Foundations Exam 3": Foundations_Exam_3,
  "Introduction to Object Oriented Programming":
    Introductionto_OPP_Part_1_Class,
  "Object Oriented Programming": Introductionto_OPP_Part_2_Class,
  "Classes & Objects": Classes_Object_Class,
  "Attributes and Methods": Attributes_Methods_Class,
  "Inheritance Part 1": Inheritance_Part_1_Class,
  "Inheritance Part 2": Inheritance_Part_2_Class,
  "Coding Practice 32": Coding_Pratice_32,
  "Coding Practice 33": Coding_Pratice_33,
  "OOP: On Demand Session": OPP_On_Demand_Session,
  "Problem Solving and Debugging Part 7": ProblemSol_Debugging_Class_7,
  "Scope & Namespaces": Scope_Namespaces_Class,
  "Errors & Exceptions": Errors_Exceptions_Class,
  "Dates & Time": Dates_Time_Class,
  "Working with Dates & Times": Workingwith_Data_Time_Class,
  "Coding Practice 34": Coding_Pratice_34,
  "Grand Assignment 5": Grand_Assignment_5,
  "Programming Foundations Course Exam | Instructions":
    Programmig_Foundations_Course_Exam_Instructions_Class,
  "Programming Foundations Course Exam": Programmig_Foundations_Course_Exam,

  //Reactjs Cheat Sheet
  "Introduction to React JS | Cheat Sheet": Introductionto_Reactjs_CS,
  "Components & Pros | Cheat Sheet": Components_Props_CS,
  "Lists & Keys | Cheat Sheet": Lists_Keys_CS,
  "Class Component and State | Cheat Sheet": Class_Component_State1_CS,
  "Conditional Rendering | Cheat Sheet": Conditional_Render_CS,
  "Class Component and State | Cheat Sheet | Part 2": Class_Component_State2_CS,
  "Common Mistakes | Cheat Sheet": Common_Mistakes_CS,
  "Debugging using Developer Tools | Cheat Sheet": Debugging_Dev_Tool_CS,
  "On Demand Session1 | Cheat Sheet": Ondemand1_Session_CS,
  "On Demand Session | Cheat Sheet | Part 2": Ondemand2_Session_CS,
  
  "Component Life Cycle | Cheat Sheet": Component_Life_Cycle_CS,
  "Routing using React Router | Cheat Sheet": React_Router1_CS,
  "Routing using React Router | Part 2 & 3| Cheat Sheet": React_Router2_3_CS,
  "Common Mistakes | Cheat Sheet | Part 2": Common_M_Part2_CS,
  "Authentication & Authorization | Cheat Sheet": Authentication_CS,
  "Authentication & Authorization | Part 2 | Cheat Sheet": Authentication_2_CS,
  "Authentication & Authorization | Part 3 | Cheat Sheet": Authentication_3_CS,
  "Common Mistakes | Part 3 | Cheat Sheet": Common_Mistake_3_CS,
  "Authentication & Authorization | Part 4 | Cheat Sheet": Authentication_P4_CS,
  "Sorting Products | Cheat Sheet": SortingProducts_CS,
  "More React Concepts | Cheat Sheet": More_React_CS,
  "Third Party Packages | Cheat Sheet": Third_Party_CS,
  "Recharts | Reading Material": Recharts,
  "React Chrono | Reading Material": React_Chrono_CS,
  "React Slick | Reading Material": React_Slick,
  "React Popup | Reading Material": React_Pop,
  "React Context | Cheat Sheet": React_Context_CS,
  "React Context | Part 2 | Cheat Sheet": React_Cpart2_CS,
  "React Context | Part 3 | Cheat Sheet": React_Cpart3_CS,
  "React Context | Part 4 | Cheat Sheet": React_Cpart4_CS,
  "Styled Components | Cheat Sheet": Styled_Compo_CS,

  //Reactjs MCQ
  "MCQ Pratice - Introduction": Introductionto_Reactjs_MCQ,
  "MCQ Pratice - Part 1": Components_Props_MCQ,
  "MCQ Pratice - Lists & Keys": Lists_Keys_MCQ,
  "MCQ Pratice - Class and State": Class_Component_State1_MCQ,
  "MCQ Pratice - Conditional Rendering": Conditional_Render_MCQ,
  "MCQ Pratice - Part 2": Class_Component_State2_MCQ,
  "MCQ Pratice - Common Mistakes": Common_Mistakes_MCQ,
  "MCQ Pratice - Debugging": Debugging_Dev_Tool_MCQ,
  "MCQ Pratice - OnDemand | Part 1": Ondemand1_Session_MCQ,
  "MCQ Pratice - OnDemand | Part 2": Ondemand2_Session_MCQ,
  "MCQ Pratice - Component Life Cycle": Component_Life_Cycle_MCQ,
  "MCQ Pratice - React Router": React_Router1_MCQ,
  "MCQ Pratice - React Router | Part 2 & 3": React_Router2_3_MCQ,
  "MCQ Pratice - Common Mistakes | Part 2": Common_M_Part2_MCQ,
  "MCQ Pratice - Authentication": Authentication_MCQ,
  "MCQ Pratice - Authentication | Part 2": Authentication_2_MCQ,
  "MCQ Pratice - Authentication | Part 3": Authentication_3_MCQ,
  "MCQ Pratice - Common Mistakes | Part 3": Common_Mistake_3_MCQ,
  "MCQ Pratice - Authentication | Part 4":Authentication_P4_MCQ,
  "MCQ Pratice - Sorting Products": SortingProducts_MCQ,
  "MCQ Pratice - More React Concepts": More_React_MCQ,
  "MCQ Pratice - Third Party Packages": Third_Party_MCQ,
  "MCQ Pratice - React Context": React_Context_MCQ,
  "MCQ Pratice - React Context | Part 2": React_Cpart2_MCQ,
  "MCQ Pratice - React Context | Part 3": React_Cpart3_MCQ,
  "MCQ Pratice - React Context | Part 4": React_Cpart4_MCQ,
  "MCQ Pratice - Styled Components": Styled_Compo_MCQ,

  //Flexbox Cheat Sheet
  "Sizing Elements and Handling Overflow | Cheat Sheet":
    Sizing_Ele_Handling_Overflow_CS,
  "Box Sizing | Cheat Sheet": Box_Sizing_CS,
  "Introduction to CSS Flexbox | Cheat Sheet": Introductionto_CSS_Flexbox_CS,
  "Introduction to CSS Flexbox | Part 2| Cheat Sheet":
    Introductionto_CSS_Flexbox_CS_2,
  "Introduction to CSS Flexbox | Part 3| Cheat Sheet":
    Introductionto_CSS_Flexbox_CS_3,

  //Python Coding Practices
  "Coding Practice - 1": Coding_Practice_1,
  "Coding Practice - 2": Coding_Practice_2,
  "Coding Practice - 3": Coding_Practice_3,

  //Python coding practices end

  // Python Cheat Sheet Start

  "Problem Solving Part 6 | Cheat Sheet": Problem_sol_6_CS,
  "Problem Solving Part 7 | Cheat Sheet": Problem_sol_7_CS,
  "How to debug your code?": How_to_Debug_Code,
  "Coding Practice Walkthrough | Part 2": Coding_Pratice_Walkthrough_2,
  "Problem Solving and Debugging | Cheat Sheet": ProblemSol_Debugging_CS,
  "Problem Solving and Debugging Part 4 | Cheat Sheet":
    Problem_sol_Debugging_4_CS,
  "Problem Solving and Debugging Part 5 | Cheat Sheet":
    Problem_sol_Debugging_5_CS,
  "MCQ Practice - Prog with Python": Pro_W_P_MCQ,
  "Variables and Data Types | Cheat Sheet": Variables_DT_CS_2,
  "MCQ Practice - Var & Data Types": Variables_DT_MCQ,
  "Programming with Python | Cheat Sheet": Pro_W_P_CS_1,
  "Sequence of Instructions | Cheat Sheet": Seq_OF_Instruction_CS_3,
  "MCQ Practice - Sequ of Instructions": Seq_OF_Instruction_MCQ,
  "Type Conversion | Cheat Sheet": Type_Con_CS_2,
  "MCQ Practice - Type Con": Type_Con_MCQ,
  "Input and Output Basics | Cheat Sheet": Inp_Oup_Basics_CS_1,
  "MCQ Practice - I/O": Inp_Oup_Basics_MCQ,
  "Relational Operators | Cheat Sheet": RelationOperator_CS_1,
  "MCQ Practice - Rel Ope": RelationOperator_MCQ,
  "Logical Operators | Cheat Sheet": LogicalOperators_CS_2,
  "MCQ Practice - Log Ope": LogicalOperators_MCQ,
  "Conditional Statements | Cheat Sheet": ConditionalStmts_CS_3,
  "MCQ Practice - Con stmts": ConditionalStmts_MCQ,
  "MCQ Practice - Problem Solv Debug": ProblemSol_Debugging_MCQ,
  "Loops | Cheat Sheet": Loops_CS_2,
  "MCQ Practice - Loops": Loops_MCQ,
  "For Loop | Cheat Sheet": ForLoop_CS_2,
  "MCQ Practice - For Loops": ForLoop_MCQ,
  "Approach for Hollow Pattern | Cheat Sheet": Approachto_HollowPattern_CS,
  "String Methods | Cheat Sheets": String_Methods_CS,
  "MCQ Practice - String Methods": String_Methods_MCQ,
  "Nested Conditional Statements | Cheat Sheet": Nested_con_CS_1,
  "Nested Loops | Cheat Sheet": NestedLoops_CS_1,
  "MCQ Practice - Nested Loops": NestedLoops_MCQ,
  "MCQ Practice - Nested Con": Nested_con_MCQ,
  "MCQ Practice - Prob_Sol": Problem_sol_6_MCQ,
  "MCQ Practice - Prob_Sol7": Problem_sol_7_MCQ,
  "String Methods | Additional Reading Material":
    String_Methods_Additional_Material_CS,
  "Loop Control Statements | Cheat Sheet": LoopControlStmts_CS_2,
  "MCQ Practice - Loop Con Stmts": LoopControlStmts_MCQ,
  "Comparing Strings & Naming Variables | Cheat Sheet":
    ComparingStrAndNamingVar_CS_1,
  "MCQ Practice - ComStr_NamVar": ComparingStrAndNamingVar_MCQ,
  "Lists | Cheat Sheet": List_CS_1,
  "MCQ Practice - Lists": List_MCQ,
  "List & Strings | Cheat Sheet": Lists_Strings_CS_1,
  "MCQ Practice - List_Str": Lists_String_MCQ,
  "Functions | Cheat Sheet": Functions_CS_2,
  "MCQ Practice - Functions": Functions_MCQ,
  "Function Arguments | Cheat Sheet": Function_Argu_CS_3,
  "MCQ Practice - Fun_Arg": Functions_Argu_MCQ,
  "Built-in Functions | Cheat Sheet": Built_in_Fun_CS_1,
  "MCQ Practice - Builtin_Fun": Built_in_Fun_MCQ,
  "Function Call Stack & Recursion | Cheat Sheet": FunCallStackRecursion,
  "MCQ Practice - FunCallStack_Recursion": FunCallStack_Recursion_MCQ,
  "List Methods | Cheat Sheet": ListMethods,
  "MCQ Practice - List Methods": ListMethods_MCQ,
  "Working with Lists | Cheat Sheet": Workingwith_Lists_CS,
  "MCQ Practice - Working_Lists": Workingwith_Lists_MCQ,
  "Tuples & Sequences | Cheat Sheet": Tuples_Sequences_CS_1,
  "MCQ Practice - Tuples_Seq": Tuples_Sequences_MCQ,
  "Sets | Cheat Sheet": Sets_CS_2,
  "MCQ Practice - Sets": Sets_MCQ,
  "Set Operations | Cheat Sheet": Set_Operations_CS_3,
  "MCQ Practice - Set_Ope": Set_Operations_MCQ,
  "Nested Lists & String Formatting | Cheat Sheet":
    NestedList_StringFormatting_CS_1,
  "MCQ Practice - NestedList_StrFormat": NestedList_Stringformating_MCQ,
  "Dictionaries | Cheat Sheet": Dictionaries_CS_2,
  "MCQ Practice - Dictionaries": Dictionaries_MCQ,
  "Buil-in Functions | Additional Reading Material":
    Builtin_Fun_Additional_Material_CS,
  "Working with Dictionaries | Cheat Sheet": Working_With_Dictionaries_CS_3,
  "MCQ Practice - Working_Dictionaries": Working_With_Dictionaries_MCQ,
  "Introduction to Object Oriented Programming | Cheat Sheet":
    Introductionto_OOP_CS_1,
  "MCQ Practice - Intro_OOP": Introductionto_OOP1_MCQ,
  "Object Oriented Programming | Cheat Sheet": Introductionto_OOP_CS_2,
  "MCQ Practice - OOP": Introduction_Opp_MCQ2,
  "Classes & Objects | Cheat Sheet": Classes_Object_CS_3,
  "MCQ Practice - Classes_Obj": Classes_Object_MCQ,
  "Attributes and Methods | Cheat Sheet": Attributes_Methods_CS_4,
  "MCQ Practice - Att_Meth": Attributes_Methods_MCQ,
  "Inheritance Part1 | Cheat Sheet": Inheritance_Part1_CS_5,
  "MCQ Practice - Inheritance1": Inheritance_Part1_MCQ,
  "Inheritance Part2 | Cheat Sheet": Inheritance_Part2_CS_2,
  "MCQ Practice - Inheritance2": Inheritance_Part2_MCQ,
  "Python Standard Library | Cheat Sheet": Python_Standard_Library_CS_1,
  "MCQ Practice - PythonLibrary": Python_Standard_Library_MCQ,
  "Scope & Namespaces | Cheat Sheet": Scope_Namespaces_CS_2,
  "MCQ Practice - Scope_Namespaces": Scope_Namespaces_MCQ,
  "Errors & Exceptions | Cheat Sheet": Errors_Exceptions_CS_3,
  "MCQ Practice - Errors_Excep": Errors_Exceptions_MCQ,
  "Dates & Time | Cheat Sheet": Dates_Time_CS_4,
  "MCQ Practice - Dates_Time": Dates_Time_MCQ,
  "Working with Dates & Times | Cheat Sheet": Workingwith_Date_Time_CS,
  "MCQ Practice - Working with Dates & Times": Workingwith_Date_Time_MCQ,
  "Python Summary Cheat Sheet - 1": Python_Summary_CS_1,
  "Python Summary Cheat Sheet - 2": Python_Summary_CS_2,
  "Python Summary Cheat Sheet - 3": Python_Summary_CS_3,
  "Python Summary Cheat Sheet - 4": Python_Summary_CS_4,
  "MCQ Practice": MCQWrapper,
  "MCQ Practice - 1": MCQWrapper,
  "MCQ Practice - 2": MCQWrapper,

  //Python End

  //Nodejs cheat-sheets
  "Introduction to Node JS | Cheat Sheet": Introductionto_Nodejs_CS,
  "MCQ Pratice - Introduction to Node JS": Introductionto_Nodejs_MCQ,
  "Common JS Module Exports | Reading Material":
    Commojs_Module_Readig_Material_CS,
  "MCQ Pratice - Common JS Module Exports": Commojs_Module_Readig_Material_MCQ,
  "ES6 Module Exports | Reading Material": ES6_Module_CS,
  "MCQ Pratice - ES6 Module Exports": ES6_Module_MCQ,
  "Introduction to Node JS | Part 2 | Cheat Sheet": Introductionto_Nodejs_CS_2,
  "MCQ Pratice - Introduction to Node JS | Part 2": Introductionto_Nodejs_MCQ_2,
  "Introduction to Express JS | Cheat Sheet": Introductionto_Expressjs_CS_1,
  "MCQ Pratice - Introduction to Express JS": Introductionto_Expressjs_MCQ_1,
  "Introduction to Express JS | Part 2 | Cheat Sheet":
    Introductionto_Expressjs_CS_2,
  "MCQ Pratice - Introduction to Express JS | Part 2":
    Introductionto_Expressjs_MCQ_2,
  "Introduction to Express JS | Part 3 | Cheat Sheet":
    Introductionto_Expressjs_CS_3,
  "MCQ Pratice - Introduction to Express JS | Part 3":
    Introductionto_Expressjs_MCQ_3,
  "REST APIs | Cheat Sheet": Rest_API_CS,
  "MCQ Pratice - REST APIs": Rest_API_MCQ,
  "Debugging Common Errors | Cheat Sheet": Debug_Cmmn_Errors_CS,
  "Debugging Common Errors | Part 2 | Cheat Sheet": Debug_Cmmn_Errors_P2_CS,
  "MCQ Pratice - Debugging Common Errors": Debug_Cmmn_Errors_MCQ,
  "Authentication | Cheat Sheet":Athantication_CS_1,
  "MCQ Pratice - Authentication":Athantication_MCQ_1,
  "Authentication | Part 2 | Cheat Sheet":Athantication_CS_2,
  "MCQ Pratice - Authentication | Part 2": Athantication_MCQ_2,
  "Authentication | Part 3 | Cheat Sheet":Athantication_CS_3,
  "MCQ Pratice - Authentication | Part 3": Athantication_MCQ_3,

  //JavaScript Class
  "Introduction to Dynamic Web Applications":
    Introductionto_Dynamic_Application_Class,
  "DOM and Event Fundamentals": Dom_Event_Fundamentals_Class,
  "Primitive Types & Conditionals": PrimitiveTypes_Conditionals_Class,
  "Input Element and Math Functions": InputEle_Mathfunctions_Class,
  "Coding Practice 1": Coding_Pratice_1,
  "Coding Practice 2": Coding_Pratice_2,
  "Coding Practice 3": Coding_Pratice_3,
  "Arrays & More DOM Manipulations": Arrays_Dom_Manipulations_Class,
  "JS Coding Platform Walk through": JS_Coding_Pratice_Walkthrough,
  "Objects": Objects_Class,
  "Comments": Comments,
  "A Note On Software Compatibility": A_Note_ON_Software_Capability,
  "JS Coding Practice 1": JS_Coding_Pratic_1,
  "JS Coding Practice 2": JS_Coding_Pratic_2,
  "JS Coding Practice 3": JS_Coding_Pratic_3,
  "JS Coding Practice 4": JS_Coding_Pratic_4,
  "Coding Practice 4": Coding_Pratice_4,
  "Coding Practice 5": Coding_Pratice_JS_5,
  "Coding Practice 6": Coding_Pratice_6,
  "Coding Practice 7": Coding_Pratice_7,
  "Coding Practice 8": Coding_Pratice_8,
  "Todos Application Introduction": Todos_Application_Introduction,
  "Todos Application | Part 1": Todos_Application_Part_1_Class,
  "On Demand Session": JavaScript_On_Demand_Session_Class,
  "Todos Application | Part 2": Todos_Application_Part_2_Class,
  "Todos Application | Part 3": Todos_Application_Part_3_Class,
  "Todos Application | Part 4": Todos_Application_Part_4_Class,
  "Coding Practice 9": Coding_Pratice_9,
  "Coding Practice 10": Coding_Pratice_10,
  "Coding Practice 11": Coding_Pratice_11,
  "JS Coding Practice 5": JS_Coding_Pratic_5,
  "JS Coding Practice 6": JS_Coding_Pratice_6,
  "JS Coding Practice 7": JS_Coding_Pratice_7,
  "Todos Application | Part 5": Todos_Application_Part_5_Class,
  "Array Methods | Practice 1": Array_Methods_Pratice_1,
  "Array Methods | Practice 2": Array_Methods_Pratice_2,
  "Array Methods | Practice 3": Array_Methods_Pratice_3,
  "Coding Practice 12": Coding_Pratice_JS_12,
  "Coding Practice 13": Coding_Pratice_13,
  "Todos Application | Part 6": Todos_Application_Part_6_Class,
  "Callbacks & Schedulers": Callbacks_Schedulers_Class,
  "Event Listeners & More Events": Event_Listners_More_Events_Class,
  "Hypertext Transfer Protocol (HTTP)": Hypertext_Transfer_Protocal_Class,
  "Coding Practice 14": Coding_Pratice_14,
  "Coding Practice 15": Coding_Pratice_15,
  "Coding Assignment 1": JS_Coding_Assignment_1,
  "HTTP Requests using JS": HTTP_Request_Using_Class,
  "Wikipedia Search Application": Wikipedia_Search_Class,
  "Coding Practice 17": Coding_Pratice_17,
  "Coding Practice 16": Coding_Pratice_JS_16,
  "Coding Practice 18": Coding_Pratice_JS_18,
  "Coding Practice 19": Coding_Pratice_JS_19,
  "Coding Practice 20": Coding_Pratice_JS_20,
  Forms: Forms_Part_1_Class,
  "Forms | Part 2": Forms_Part_2_Class,
  "Coding Assignment 2": JS_Coding_Assignment_2,
  "Coding Assignment 3": JS_Coding_Assignment_3,
  "Coding Test 1": Coding_Test_1,
  "Coding Test 2": Coding_Test_2,
  "Coding Test 3": Coding_Test_3,
  "Coding Test 4": Coding_Test_4,
  "JS Coding Test 1": JS_Coding_Test_1,
  "JS Coding Test 2": JS_Coding_Test_2,
  "MCQ Test 1": MCQ_Test_1,
  "MCQ Test 2": MCQ_Test_2,
  "Build Your Own Dynamic Web Application Course Exam | Instructions":
    Dynamic_Course_Exam_Instructions_Class,
  "Build Your Own Dynamic Web Application Course Exam": Dynamic_Course_Exam,
  //JavaScript Start
  "Introduction to Dynamic Web Applications | Cheat Sheet":
    Introductionto_Dynamic_Application_CS,
  "MCQ Practice - Intro_Dynamic Web App":
    Introductionto_Dynamic_Application_MCQ,
  "DOM and Event Fundamentals | Cheat Sheet": DOM_Event_Fundamentals_CS,
  "MCQ Practice - DOM Event Fund": Dom_Event_Fundamentals_MCQ,
  "Primitive Types & Conditionals | Cheat Sheet":
    Primitive_Types_Conditionals_CS,
  "MCQ Practice - Primitive Types": PrimitiveTypes_Conditionals_MCQ,
  "Input Element and Math Functions | Cheat Sheet": InputEle_MathFunctions_CS,
  "MCQ Practice - Input Elements": InputEle_MathFunctions_MCQ ,
  "Arrays & More DOM Manipulations | Cheat Sheet": Arrays_Dom_Manipulations_CS,
  "MCQ Practice - Array & DOM": Arrays_Dom_Manipulations_MCQ,
  "Objects | Cheat Sheet": Objects_CS,
  "MCQ Practice - Objects": Objects_MCQ,
  "Todos Application | Cheat Sheet": Todos_Applications_CS,
  "MCQ Practice - Todos App": Todos_Applications_MCQ,
  "On Demand Session | Cheat Sheet": JavaScript_On_Demand_Session_CS,
  "MCQ Practice - On Demand Session": On_Demand_Session_MCQ,
  "Todos Application | Part 2 | Cheat Sheet": Todos_Application_CS_2,
  "MCQ Practice - Todos App 2": Todos_Application_MCQ_2,
  "Todos Application | Part 3 | Cheat Sheet": Todos_Application_CS_3,
  "MCQ Practice - Todos App 3": Todos_Application_MCQ_3,
  "Todos Application | Part 4 | Cheat Sheet": Todos_Application_CS_4,
  "MCQ Practice - Todos App 4": Todos_Application_MCQ_4,
  "Todos Application | Part 5 | Cheat Sheet": Todos_Application_CS_5,
  "MCQ Practice - Todos App 5": Todos_Application_MCQ_5,
  "Todos Application | Part 6 | Cheat Sheet": Todos_Application_CS_6,
  "MCQ Practice - Todos App 6": Todos_Application_MCQ_6,
  "Callbacks & Schedulers | Cheat Sheet": Callbacks_Schedulers_CS,
  "MCQ Practice - Callbacks & Schedulers": Callbacks_Schedulers_MCQ,
  "Event Listeners & More Events | Cheat Sheet": Event_Listners_More_Events_CS,
  "MCQ Practice - Event Listeners": Event_Listners_More_Events_MCQ,
  "Hypertext Transfer Protocal (HTTP) | Cheat Sheet":
    Hypertext_Transfer_Protocal_CS,
  "MCQ Practice - HTTP": Hypertext_Transer_Protocal_MCQ,
  "Wikipedia Search Application | Cheat Sheet": Wikipedia_Search_CS,
  "HTTP Requests using JS | Cheat Sheet": HTTP_Request_Using_JS_CS,
  "MCQ Practice - HTTP Requests using JS": HTTP_Request_Using_JS_MCQ,
  "MCQ Practice - Wikipedia Application": Wikipedia_Search_MCQ,
  "Forms | Cheat sheet": Forms_CS,
  "MCQ Practice - Forms": Forms_MCQ_1,
  "Forms | Part - 2 | Cheat sheet": Forms_CS_2,
  "MCQ Practice - Forms Part 2": Forms_MCQ_2,
  "MCQ Assignment 1": JS_MCQ_Assignment_1,
  "MCQ Assignment 2": JS_MCQ_Assignment_2,
  "MCQ Assignment 3": JS_MCQ_Assignment_3,
  "MCQ Assignment 4": JS_MCQ_Assignment_4,
  "JS MCQ Test 1": JS_MCQ_Test_1,
  "JS MCQ Test 2": JS_MCQ_Test_2,

  //git
  "Understanding Binary | Cheat Sheet":Understaing_Binary_CS,
  "MCQ Pratice - Understanding Binary":Understaing_Binary_MCQ,
  "Overview of Computer Hardware | Cheat Sheet":Computer_Hardware_CS,
  "MCQ Pratice - Overview of Computer Hardware": Computer_Hardware_MCQ,
  "Introduction to Operating System | Cheat Sheet":Introductionto_Operating_System_CS,
  "MCQ Pratice - Introduction to Operating System":Introductionto_Operating_System_MCQ,
  "Overview of Process Management | Cheat Sheet": Process_Managent_CS,
  "MCQ Pratice - Overview of Process Management":Process_Managent_MCQ,
  "Threads & Concurrency | Cheat Sheet":Threads_Courrency_CS,
  "MCQ Pratice - Threads & Concurrency": Threads_Courrency_MCQ,
  "Memory Management | Cheat Sheet":Memory_Managent_CS,
  "MCQ Pratice - Memory Management":Memory_Managent_MCQ,
  "Understanding Computer Networks": Compter_Networks,
  "Understanding Computer Networks | Cheat Sheet":Compter_Networks_CS,
  "MCQ Pratice - Understanding Computer Networks": Compter_Networks_MCQ,
  "Network Layer | Cheat Sheet":Network_Layer_CS,
  "MCQ Pratice - Network Layer": Network_Layer_MCQ,
  "Transport Layer | Cheat Sheet":Transport_Layers_CS,
  "MCQ Pratice - Transport Layer":Transport_Layers_MCQ,
  "Application Layer | Cheat Sheet":Application_Layer_CS,
  "MCQ Pratice -Application Layer":Application_Layer_MCQ,
  "Getting Started with Command Line | Cheat Sheet": Working_Command_Line_CS,
  "MCQ Pratice - Getting Started with Command Line" :Working_Command_Line_MCQ,
  "Setting Up WSL2 Manual":Settingup_WSL2_CS,
  "Working with File System | Cheat Sheet": Working_File_System_CS,
  "Working with Files | Cheat Sheet": Working_with_Files_CS,
  "MCQ Pratice - Working with Files": Working_with_Files_MCQ,
  "MCQ Pratice - Working with File System": Working_File_System_MCQ,
  "Miscellaneous Commands - 1 | Cheat Sheet": Miscellaneous_Commands_CS_1,
  "MCQ Pratice - Miscellaneous Commands - 1": Miscellaneous_Commands_MCQ_1,
  "Miscellaneous Commands - 2 | Cheat Sheet": Miscellaneous_Commands_CS_2,
  "MCQ Pratice -Miscellaneous Commands - 2" :Miscellaneous_Commands_MCQ_2,
  "Getting Started with Git | Cheat Sheet":Getting_Started_Git_CS,
  "MCQ Pratice - Getting Started with Git": Getting_Started_Git_MCQ,
  "Staging Area & Commits | Cheat Sheet":Staging_Area_Commits_CS ,
   "MCQ Pratice - Staging Area & Commits":Staging_Area_Commits_MCQ,
  

};
